export default {
    "accountValidateMsg" : "ชื่อบัญชีต้องยาว 6-30 ตัวอักษร ประกอบด้วยพยัญชนะ ตัวเลข และสัญลักษณ์พิเศษ (“.”,“_”,“@”) ตัวอักษรแรกต้องเป็นตัวเลข หรือพยัญชนะเท่านั้น",
    "storeSuccess" : "เติมเงินสำเร็จ",
    "editAccountTips" : "โปรดป้อนบัญชีให้ถูกต้อง",
    "editPwdTips" : "โปรดป้อนรหัสผ่านให้ถูกต้อง",
    "editRepeatPwdTips" : "โปรดป้อนรหัสผ่านอีกใหม่",
    "pwdRepeatTips" : "รหัสผ่านไม่ตรงกัน",
    "changePwdSucc" : "แก้ไขรหัสผ่านสำเร็จ",
    "bindEmail" : "ผูกมัดอีเมล",
    "verifyEmail" : "การยืนยันความปลอดภัยบัญชี",
    "errorVrifyCodeTips" : "รหัสยืนยันไม่ถูกต้อง",
    "slectQuessionTips" : "โปรดเลือกคำถามเพื่อความปลอดภัย",
    "answerTips" : "โปรดป้อนคำตอบ",
    "twoAnswerTips" : "โปรดเลือกคำถามเพื่อความปลอดภัยที่ตั้งค่าไว้ 2 ข้อ และป้อนคำตอบที่ถูกต้อง",
    "realNameValidateTips" : "โปรดป้อนชื่อ-สกุล (4-60)",
    "phoneValidateTips" : "โปรดป้อนเบอร์โทร (ตัวเลข 6-18 หลัก)",
    "areaSelectTips" : "โปรดเลือกประเทศให้ถูกต้อง",
    "iDCardValidataTips" : "โปรดป้อนเลขบัตรประชาชน (ตัวเลข 1-60 หลัก)",
    "changeProfileSucc" : "แก้ไขข้อมูลสำเร็จ",
    "editVrfCodeTips" : "โปรดป้อนรหัสยืนยัน",
    "securityQuestionTips" : "โปรดตั้งค่าคำถามเพื่อความปลอดภัยของบัญชี เมื่อคุณลืมรหัสผ่าน จะรีเซ็ตรหัสผ่านได้รวดเร็วด้วยการตอบคำถามจากคำถามที่ตั้งไว้",
    "validateQuessionTips" : "โปรดเลือกคำถามที่ไม่ซ้ำกัน 2 ข้อเพื่อยืนยัน หลังยืนยันจะรีเซ็ตคำถามเพื่อความปลอดภัยได้",
    "originPwd" : "โปรดป้อนรหัสผ่านเดิม",
    "newPwd" : "โปรดป้อนรหัสผ่านใหม่",
    "changePwdSuccess" : "แก้ไขรหัสผ่านสำเร็จ โปรดล็อกอินใหม่ เพื่อป้องกันข้อมูลสูญหาย",
    "accountName" : "โปรดป้อนชื่อบัญชี",
    "password" : "โปรดป้อนรหัสผ่าน",
    "repeatPassword" : "โปรดป้อนรหัสผ่านอีกครั้ง",
    "findPwdTips" : "โปรดป้อนชื่อบัญชีที่จะกู้รหัสผ่าน",
    "submit" : "ส่ง",
    "send" : "ส่ง",
    "modify" : "แก้ไข",
    "haveAgree" : "ยอมรับ",
    "and" : "และ",
    "privacyPolicy" : "นโยบายความเป็นส่วนตัว",
    "completeness" : "ค่าสำเร็จ",
    "gender" : "เพศ",
    "male" : "ชาย",
    "female" : "หญิง",
    "birthday" : "วันเกิด",
    "phone" : "เบอร์โทร",
    "region" : "ประเทศ/เขต",
    "ID" : "พาสปอร์ตหรือเลขบัตรประชาชน",
    "accountSetting" : "ตั้งค่าบัญชี",
    "upgrade" : "อัปเกรดบัญชี",
    "profile" : "ข้อมูลส่วนบุคคล",
    "changePassword" : "แก้ไขรหัสผ่าน",
    "securityQuestion" : "คำถามเพื่อความปลอดภัย",
    "creatework_headerTitle" : "สร้างใบแจ้งปัญหา",
    "mylist_headerTitle" : "ใบแจ้งปัญหาของฉัน",
    "bindEmailTips" : "โปรดยืนยันอีเมลที่ใช้บ่อย เพื่อเพิ่มความปลอดภัยของบัญชีหากลืมรหัสผ่าน จะสามารถรีเซ็ตรหัสผ่านจากอีเมลนี้ได้",
    "verifyEmailTips" : "ตรวจพบว่าบัญชีของคุณกำลังเข้าสู่ระบบจากอุปกรณ์ใหม่หรือสภาพแวดล้อมที่ผิดปกติ เพื่อความปลอดภัยของทรัพย์สินในบัญชี กรุณายืนยันตัวตนให้เสร็จสิ้น",
    "enterEmailVrfcationTips" : "โปรดกรอกรหัสยืนยันที่ได้รับ",
    "cancel" : "ยกเลิก",
    "bindTps" : "การผูกมัดบัญชีจะสามารถเข้าสู่บัญชีเกมของคุณบนอุปกรณ์ได้หลายเครื่อง",
    "login" : "ล็อกอิน",
    "logout" : "ล็อกเอาต์",
    "bind" : "ผูกมัดบัญชี",
    "feedback" : "เสนอแนะ",
    "terms" : "เกี่ยวกับเงื่อนไข",
    "tips" : "โปรดทราบ",
    "debindTips" : "หลังยกเลิกการผูกมัดอาจทำให้ข้อมูลบัญชีของคุณสูญหาย ยืนยันจะยกเลิกการผูกบัญชีหรือไม่!",
    "debindText" : "ยกเลิกการผูกมัด",
    "guestSwitchTips" : "ขณะนี้คุณมีบัญชีผู้เยี่ยมชมแล้ว หลังล็อกอินบัญชีผู้เยี่ยมชมนี้จะสูญหาย ยืนยันจะล็อกอินหรือไม่?",
    "register" : "สมัคร",
    "realName" : "ชื่อ-สกุล",
    "enterEmailTips" : "ป้อนอีเมล",
    "emailVAlidateMsg" : "อีเมลไม่ถูกต้อง",
    "editEmaileTips" : "โปรดป้อนอีเมล",
    "checkServiceTips" : "โปรดอ่านและยอมรับเงื่อนไขการให้บริการและนโยบายความเป็นส่วนตัว!",
    "brithdayValidateTips" : "โปรดเลือกวันเกิดให้ถูกต้อง",
    "facebookValidateTips" : "โปรดป้อนบัญชี Facebook (1-60 ตัวอักษร)",
    "eritOriginPwdTips" : "โปรดป้อนรหัสผ่านเดิม",
    "submitSuccess" : "ส่งสำเร็จ",
    "rebindEmail" : "แก้ไขอีเมล",
    "bindEmailSuccess" : "คุณผูกมัด\$emailสำเร็จแล้ว</br>หลังใช้บัญชีที่ผูกมัดยืนยัน จะรีเซ็ตอีเมลได้",
    "reSetSecurityQuessoon" : "ตั้งค่าคำถามเพื่อความปลอดภัยสำเร็จแล้ว<br/><br/>โปรดเลือกคำถามที่ไม่ซ้ำกันเพื่อทำการยืนยัน หลังยืนยันจะรีเซ็ตคำถามได้",
    "canotModifyTips" : "หลังส่งข้อมูลส่วนบุคคลจะแก้ไขไม่ได้ ยืนยันจะส่งหรือไม่?",
    "rebindEmailTips" : "อีเมลของคุณ \$email โปรดกดรับรหัสยืนยันและป้อนรหัสยืนยันที่ได้รับ",
    "reGetVrfCode" : "รับรหัสยืนยัน",
    "findPwdWayTips" : "โปรดเลือกวิธีกู้รหัสผ่านดังนี้",
    "emailWay" : "กู้ผ่านอีเมลเพื่อความปลอดภัย",
    "emailWayTips" : "หลังได้รับอีเมลยืนยัน จะตั้งค่ารหัสผ่านใหม่ได้",
    "quessionWay" : "กู้ผ่านคำถามเพื่อความปลอดภัย",
    "quessionWayTips" : "ตอบคำถามของคำถามเพื่อความปลอดภัย จะตั้งค่ารหัสผ่านใหม่ได้",
    "resetPwdBtn" : "รีเซ็ตรหัสผ่าน",
    "lastStep" : "ขั้นตอนที่แล้ว",
    "sendEmailTips" : "เราได้ส่งอีเมลยืนยันไปยังอีเมลของคุณ \$email แล้ว<br>โปรดป้อนรหัสยืนยันที่ได้รับให้ถูกต้อง",
    "setNewPwdTips" : "ยินดีด้วย!<br>ตั้งค่ารหัสผ่านใหม่ได้แล้ว โปรดป้อนรหัสผ่านใหม่ในกรอบแชท!",
    "termsOfUse" : "เงื่อนไขการให้บริการ",
    "copy_success" : "คัดลอกสำเร็จ",
    "creatework_create" : "ประเภทใบแจ้งปัญหา",
    "creatework_createHolder" : "โปรดเลือกประเภท",
    "creatework_title" : "หัวข้อ",
    "creatework_titleHolder" : "โปรดป้อนหัวข้อ",
    "creatework_detail" : "รายละเอียด",
    "creatework_detailHolder" : "โปรดป้อนรายละเอียดไม่เกิน 200 ตัวอักษร",
    "creatework_uploadTips" : "อัปโหลดไฟล์ jpg/png ได้เท่านั้น ไฟล์เอกสารต้องห้ามเกิน 5mb",
    "creatework_selectBox_selectTile" : "ประเภทของปัญหา",
    "creatework_goGame" : "กลับสู่เกม",
    "creatework_history" : "ประวัติใบแจ้งปัญหา",
    "mylist_noYet" : "ไม่มีประวัติใบแจ้งปัญหา",
    "mywork_solved" : "แก้ปัญหาแล้ว? กดที่นี่",
    "mywork_service" : "ให้คะแนนฝ่ายบริการลูกค้า",
    "mywork_messageHolder" : "โปรดป้อนข้อความใหม่",
    "mywork_score" : "โปรดเลือกคะแนน",
    "mywork_confirm" : "ยืนยัน",
    "creatework_selectBox_selectList3" : "ปัญหาอื่นๆ",
    "creatework_selectBox_selectList2" : "ปัญหาเกี่ยวกับบัญชี",
    "close" : "ปิด",
    "creatework_gameHolder" : "โปรดเลือกเกม",
    "creatework_serverHolder" : "โปรดเลือกเซิร์ฟเวอร์",
    "contactService" : "ติดต่อฝ่ายบริการลูกค้า",
    "FAQ" : "FAQ",
    "creatework_game" : "เกม:",
    "creatework_server" : "เซิร์ฟเวอร์:",
    "creatework_role" : "ตัวละคร:",
    "selectRoleName" : "โปรดเลือกตัวละคร",
    "creatework_noRole" : "ยังไม่สร้างตัวละคร",
    "creatework_noGame" : "รายชื่อเกมว่างเปล่า",
    "creatework_noServer" : "รายชื่อเซิร์ฟว่างเปล่า",
    "termText" : "ฉันได้อ่านและยอมรับใน",
    "backLogin" : "ล็อกอิน",
    "creatework_roleHolder" : "โปรดเลือกตัวละครก่อน",
    "findPwdFailTips" : "คุณยังไม่ตั้งค่าคำถามและอีเมลเพื่อความปลอดภัย จึงกู้รหัสผ่านด้วยวิธีนี้ไม่ได้ โปรดติดต่อฝ่ายบริการลูกค้า",
    "payMall" : "ห้างเติมเงิน",
    "selectPayment" : "เลือกยอดเติมเงิน",
    "plzSelectPayWay" : "โปรดเลือกช่องทาง",
    "gainPlus" : "โบนัส",
    "gainMorePlus" : "โบนัสสูง",
    "gainMostPlus" : "โบนัสสูงสุด",
    "plzSelectPayType" : "เลือกวิธีเติมเงิน",
    "roleName" : "ชื่อตัวละคร",
    "payWay" : "ช่องทางชำระเงิน",
    "plzSelectOtherWay" : "โปรดเลือกช่องทางอื่น",
    "payment" : "ยอดชำระเงิน",
    "compensateTips" : "ส่วนที่สูงกว่ามูลค่าของสินค้า จะคืนเป็น \$gameCode",
    "extaGain" : "แจกเพิ่ม",
    "gameGold" : "สกุลเงินในเกม",
    "compensate" : "ชดเชย",
    "payWayPlus" : "โบนัส",
    "neddPay" : "ต้องชำระเงิน",
    "submitOrder" : "สั่งซื้อ",
    "screenshotTips" : "หมายเหตุ:แคปเจอร์หน้าจอเพื่อบันทึกข้อมูลสั่งซื้อ เพื่อใช้เป็นข้อมูลหากมีปัญหาในภายหลัง!",
    "storeFail" : "เติมเงินไม่สำเร็จ",
    "storeFailTips" : "ขออภัย ท่านเติมเงินไม่สำเร็จ โปรดสั่งซื้ออีกครั้ง หรือแจ้งปัญหาให้ฝ่ายบริการลูกค้า",
    "storeAcceptance" : "กำลังทำรายการ",
    "storeSuccessTips" : "หลังเติมเงินสำเร็จ จะได้รับยอดเงินภายใน 15 นาที",
    "orderNumber" : "รหัสสั่งซื้อ",
    "buyProduct" : "สินค้า",
    "transactionAmount" : "ยอดเงิน",
    "failReason" : "สาเหตุล้มเหลว",
    "payOntherORder" : "เติมเงินอีกครั้ง",
    "reStore" : "เติมเงินใหม่",
    "confirm" : "ยืนยัน",
    "switch" : "เปลี่ยนบัญชี",
    "completeTips" : "โปรดป้อนข้อมูลของท่าน <mark class=\"yellowMarkColor\">หลังยืนยันข้อมูลเหล่านี้แล้ว จะไม่สามารถเปลี่ยนแปลงได้</mark> หากบัญชีของท่านสูญหายหรือถูกแฮค สามารถแจ้งข้อมูลเหล่านี้ของท่านกับฝ่ายบริการลูกค้าเพื่อใช้เป็นหลักฐานกู้บัญชีได้",
    "creatework_selectBox_selectList0" : "ปัญหาตัวเกม",
    "creatework_selectBox_selectList1" : "ปัญหาชำระเงิน",
    "creatework_selectBox_selectList4" : "ปัญหาด้านภาษา",
    "mywork_solvedText" : "แก้ไขปัญหาแล้ว",
    "browserPayErrBtnText" : "ปัญหาการเติมเงิน",
    "browserPaySucBtnText" : "เติมเงินเสร็จสิ้นแล้ว",
    "browserPayingTips" : "ท่านกำลังชำระเงินในแพตลฟอร์มที่ 3 <br/> หลังชำระเงินเสร็จสิ้น สามารถปิดหน้านี้ได้",
    "price_list_empty" : "ไม่มียอดเงินที่เลือกได้",
    "pointCardTips" : "หมายเหตุ:ต้องใช้บัตรเติมเงินที่มีมูลค่าเท่ากับ \$paymentAmount เท่านั้น",
    "forgetPwd" : "ลืมรหัสผ่าน",
    "payCenter" : "ศูนย์เติมเงิน",
    "willGet" : "ท่านจะได้รับ",
    "goods" : "สินค้า",
    "discount" : "แถม",
    "payDiscount" : "ชดเชยการชำระเงิน",
    "payDiscountTips" : "ส่วนที่เกินมาจากราคาสินค้าจะชดเชยให้ท่าน",
    "hasQuestionPlease" : "หากมีข้อสงสัย โปรด",
    "pwdValidateMsg" : "รหัสผ่านต้องยาว 6-20 ตัวอักษร",
    "payWayPlusC" : "แถม",
    "fwtk" : "ข้อตกลงการให้บริการ",
    "yszc" : "นโยบายความเป็นส่วนตัว",
    "exchange" : "แลกเปลี่ยนรหัสของขวัญ",
    "remember" : "จดจำฉัน",
    "thirdInfo" : "เกี่ยวกับบัญชี",
    "thirdInfoContent" : "โปรดผูกมัดบัญชีในศูนย์ผู้ใช้งาน แล้วจึงล็อกอินด้วยบัญชีที่ผูกมัด",
    "unLink" : "ไม่สนับสนุนช่องทางนี้",
    "favour" : "บันทึกเกม",
    "goStoreTip" : "โปรดเปิดหน้าเติมเงินก่อนไป",
    "go" : "ไป",
    "otherLogin" : "ล็อกอินด้วยช่องทางอื่น",
    "qrCodeTip" : "สแกน และไปสนุกกันเลย !",
    "favourTip" : "บันทึกหน้านี้ไว้ในบราวเซอร์ เพื่อความสะดวกในการเล่นครั้งหน้า",
    "share" : "แชร์ให้เพื่อน",
    "landscapeTip" : "โปรดทำรายการด้วยหน้าจอแนวตั้ง",
    "leaveTip" : "ท่านแน่ใจไหมว่าจะออกจากเกม ?",
    "selectRole" : "โปรดเลือกตัวละครที่ต้องการเติมเงิน",
    "selectMoney" : "โปรดเลือกไอเทมที่ต้องการซื้อ",
    "seletGameInfoFirst" : "โปรดเลือกข้อมูลตัวละคร",
    "lowerIE" : "เวอร์ชั่น IE ของท่านต่ำเกินไป",
    "linkTermText" : "ฉันยินยอมใน[ข้อตกลงการให้บริการ]และ[นโยบายความเป็นส่วนตัว]ของ {mainHost} แล้ว",
    "download" : "ดาวน์โหลด",
    "favourAndDownloadTip" : "บันทึกเพจนี้ไว้ในบุ๊คมาร์ค หรือดาวน์โหลด",
    "payReward" : "เติมเงินมีรางวัล",
    "hasEqualReward" : "การเติมเงินทั้ง 2 แบบร่วมโปรโมชั่นเติมเงินครั้งแรกรับ 2 เท่า",
    "payBtnText" : "ชำระเงิน",
    "storeHoaveReward" : "โปรโมชั่น",
    "showMorePayWay" : "แสดงช่องทางชำระเงินอื่น ๆ",
    "needPaymentCount" : "ต้องชำระเงิน",
    "orderDetail" : "รายละเอียด",
    "selectPayWayPlz" : "เลือกการชำระเงิน",
    "countryCode" : "รหัสประเทศ",
    "deleteaccount_title1" : "การลบข้อมูลของบัญชี",
    "deleteaccount_title2" : "คำขอลบบัญชี",
    "deleteaccount_step1_1" : "หากท่านลบบัญชี บัญชีของท่านจะถูกอายัด 14 วัน จากนั้นจะถูกลบออจากระบบถาวร และไม่สามารถใช้บัญชีแพลตฟอร์มโซเชียลล็อกอินได้",
    "deleteaccount_step1_2" : "ระหว่างถูกอายัด ท่านสามารถยกเลิกคำขอลบบัญชีผ่านลิงก์ด้านล่างได้",
    "deleteaccount_step1_3" : "หลังบัญชีถูกลบ ข้อมูลทั้งหมดของบัญชีจะถูกลบออกจากระบบ และไม่สามารถกู้คืนได้ และท่านก็จะไม่ได้รับการชดเชยใด ๆ",
    "deleteaccount_step1_4" : "ท่านแน่ใจไหมว่าจะลบบัญชี ?",
    "deleteaccount_step2_1" : "ท่านแน่ใจไหมว่าจะลบ\n บัญชีนี้ รวมถึงข้อมูลของตัวละครทั้งหมดในเกม ?",
    "deleteaccount_step2_2" : "โปรดป้อน \"Delete\" เพื่อยืนยันการลบ",
    "deleteaccount_step3" : "หลังยื่นคำขอลบบัญชี ระบบจะทำรายการในอีก 14 วัน",
    "accountrecovery_note" : "หมายเหตุ :",
    "accountrecovery_tips" : "ยกเลิกคำขอลบบัญชีในช่วงที่บัญชีถูกอายัดได้เท่านั้น",
    "accountrecovery_Submitted2" : "ท่านขอยกเลิกคำขอลบบัญชีแล้ว\n อีกสักครู่ บัญชีของท่านจะสามารถใช้งานได้ปกติ",
    "accountrecovery_Failed" : "ส่งไม่สำเร็จ",
    "accountrecovery_Failed_1" : "บัญชีที่ท่านส่งคำขออยู่ในสถานะปกติ",
    "accountrecovery_Failed_2" : "เช็คข้อมูลของตัวละครไม่สำเร็จ โปรดป้อนใหม่",
    "accountrecovery_success" : "ฟื้นฟูบัญชีสำเร็จ",
    "account_normal" : "สถานะของบัญชีผิดปกติ จึงไม่สามารถฟื้นฟู",
    "account_unablerestore" : "บัญชีถูกยกเลิกแล้ว จึงไม่สามารถฟื้นฟู",
    "accountrecovery_roleHolder" : "โปรดป้อนชื่อตัวละคร",
    "accountrecovery_headerTitle" : "ฟื้นฟูบัญชี",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "แก้ไขบัญชี",
    "inputAccount" : "โปรดป้อนชื่อบัญชีที่ต้องการแก้ไข",
    "applyForAccountFix" : "ยื่นคำขอแก้ไขบัญชี",
    "nonEnterItem" : "ท่านยังไม่ได้ป้อน:เวลาที่สมัคร รุ่นโทรศัพท์ที่ใช้บ่อย เลขบัตรประชาชน/พาสปอร์ต และอีเมล",
    "resetOT" : "การอนุมัติหมดอายุแล้ว โปรดยื่นขอการอนุมัติใหม่",
    "addOT" : "หมดเวลาเพิ่มเติมข้อมูลแล้ว โปรดยื่นขอการอนุมัติใหม่",
    "errorPwd" : "รหัสผ่านต้องยาว 6-20 ตัวอักษร(A-Z；0-9;\".\";\"_\";\"@\")",
    "verifyAccount" : "ขาดข้อมูลบัญชีผู้ใช้งาน โปรดยืนยันใหม่",
    "selectRegisterTime" : "โปรดเลือกเวลาที่สมัคร",
    "enterBindEmail" : "โปรดป้อนอีเมลที่ผูกมัดแล้ว",
    "enterUsedPhoneType" : "โปรดป้อนรุ่นโทรศัพท์ที่ใช้บ่อย",
    "enterIdfaGpid" : "โปรดป้อนระบบปฏิบัติการใช้บ่อย",
    "enterContactEmail" : "อีเมลไม่ถูกต้อง โปรดป้อนใหม่",
    "confirmTermsPrivacy" : "โปรดยินยอมเงื่อนไขการให้บริการและนโยบายความเป็นส่วนตัว",
    "enterRechargeRemark" : "โปรดป้อนบันทึกเติมเงิน",
    "uploadImg" : "โปรดอัปโหลดสำเนาบัตรประชาชนที่มีขนาดไม่เกิน 20M",
    "selectIDType" : "โปรดเลือกประเภทเอกสารยืนยัน",
    "enterIDNum" : "โปรดป้อนเลขบัตรประชาชน/พาสปอร์ต",
    "enterIP" : "โปรดป้อน IP ที่ใช้สมัคร",
    "enterQueryNum" : "โปรดป้อนรหัสการเช็ค",
    "enterQueryPwd" : "โปรดป้อนรหัสผ่านการเช็ค",
    "errorQueryItem" : "รหัสหรือรหัสผ่านการเช็คไม่ถูกต้อง โปรดป้อนใหม่",
    "enterPassword" : "โปรดป้อนรหัสผ่านใหม่",
    "enterPasswordAgain" : "โปรดป้อนรหัสผ่านใหม่อีกครั้ง",
    "enterPasswordNonSame" : "รหัสผ่านไม่ตรงกัน",
    "enterEmail" : "โปรดป้อนอีเมล",
    "sendSuccess" : "ส่งอีเมลสำเร็จ",
    "enterCode" : "โปรดป้อนรหัสยืนยัน",
    "errorCode" : "รหัสยืนยันไม่ถูกต้อง",
    "selectQuest" : "โปรดเลือกคำถามยืนยัน",
    "enterAnswer" : "โปรดป้อนคำตอบ",
    "selectDifferQuest" : "โปรดเลือกคำถามยืนยัน 3 ข้อ และตอบ",
    "addSuccess" : "เพิ่มเติมข้อมูลสำเร็จ",
    "picFormt" : "ภาพต้องเป็นนามสกุล JPG PNG หรือ GIF",
    "countdownBefore" : "รีเซ็ตข้อมูลได้ถึง:",
    "countdownAfter" : "(เมื่อเวลากลายเป็น 00:00:00 ลิงก์จะหมดอายุ และท่านต้องยื่นแก้ไขบัญชีใหม่)",
    "uploadDone" : "อัปโหลดสำเร็จ",
    "uploadFail" : "อัปโหลดล้มเหลว",
    "applySuccess" : "ยื่นเรื่องสำเร็จ",
    "applyFailed" : "ยื่นเรื่องไม่สำเร็จ",
    "resetQuestAlterFailed" : "แก้ไขคำถามยืนยันไม่สำเร็จ",
    "resetQuestError" : "ข้อมูลไม่ถูกต้อง",
    "resetQuestNone" : "ไม่พบการสั่งซื้อนี้",
    "resetQuestAltered" : "เคยแก้ไขคำถามยืนยันแล้ว",
    "illegalOperation" : "การปฏิบัติไม่ถูกต้อง",
    "queryNotExist" : "ไม่มีรหัสการเช็ค",
    "queryPasswordError" : "รหัสผ่านไม่ถูกต้อง",
    "auditing" : "กำลังตรวจสอบข้อมูล",
    "notPass" : "ไม่ผ่าน",
    "suppleInformation" : "เพิ่มข้อมูล",
    "suppleInformationUnHandle" : "เพิ่มข้อมูลแล้ว รอฝ่ายบริการลูกค้าทำรายการ",
    "suppleInformationTimeout" : "หมดเวลาเพิ่มข้อมูล",
    "repairedAccountSuccess" : "แก้ไขบัญชีเสร็จสิ้นแล้ว",
    "repairedAccountLost" : "การแก้ไขบัญชีไม่เป็นผลแล้ว",
    "loginStateNone" : "ไม่ได้ล็อกอิน หรือ session หมดอายุ",
    "repairedAccountTimeout" : "หมดเวลาแก้ไขบัญชีแล้ว",
    "changePasswordSucc" : "แก้ไขรหัสผ่านสำเร็จ",
    "emailSendFailed" : "ส่งอีเมลไม่สำเร็จ",
    "emailSendLimit" : "วันนี้ีอีเมลนี้ไม่มีสิทธิ์รับรหัสยืนยันแล้ว",
    "repairedAccountTimeout2" : "ปฏิบัติไม่สำเร็จ และหมดเวลาแก้ไขบัญชีแล้ว",
    "emailCodeSended" : "ส่งรหัสยืนยันเข้าอีเมลแล้ว",
    "alterSuccess" : "แก้ไขสำเร็จ",
    "questionAlterSuccess" : "แก้ไขคำถามยืนยันสำเร็จ",
    "username" : "โปรด",
    "code" : "โปรดป้อนรหัสยืนยัน",
    "selectServiceType" : "โปรดเลือกการบริการ",
    "submitForm" : "แก้ไขบัญชีของท่านผ่านการส่งใบงาน",
    "apply" : "ยื่นเรื่องแก้ไข",
    "reviewApplicationStatus" : "ความคืบหน้า",
    "instantReviewOfTheStatus" : "เช็คความคืบหน้าการแก้ไขบัญชี",
    "reviewStatus" : "เช็คความคืบหน้า",
    "backToLogin" : "กลับหน้าล็อกอิน",
    "previous" : "ขั้นที่แล้ว",
    "applyDesc" : "โปรดป้อนข้อมูลต่อไปนี้ให้สมบูรณ์ เพื่อที่เราจะช่วยท่านแก้ไขปัญหาโดยเร็วที่สุด ห้ามเว้นว่างข้อที่มี* หากไม่มี โปรดป้อน ไม่มี",
    "additionalServices" : "บริการเสริม",
    "resetSecurityEmail" : "รีเซ็ตอีเมล์ยืนยัน",
    "resetSecurityQuest" : "รีเซ็ตคำถามยืนยัน",
    "registrationDate" : "สมัครเมื่อ",
    "month" : "เดือน",
    "year" : "ปี",
    "emailBound" : "โปรดป้อนอีเมลที่ผูกมัดแล้ว",
    "modelNumber" : "เพิ่มข้อมูลรุ่นอุปกรณ์ที่ใช้บ่อย;",
    "deviceName" : "โปรดป้อนรุ่นโทรศัพท์ที่ใช้บ่อย",
    "provideRecharge" : "โปรดป้อนประวัติการเติมเงินอย่างละเอียดและสมบูรณ์ เช่น ช่องทางเติมเงิน เวลา จำนวนเงิน และรหัสการสั่งซื้อ",
    "selectCountry" : "เลือกประเทศ",
    "passportID" : "บัตรประชาชน/พาสปอร์ต",
    "upload" : "อัปโหลด",
    "del" : "ลบ",
    "pleaseUpload" : "โปรดอัปโหลดสำเนาบัตรประชาชนที่มีขนาดไม่เกิน 20M",
    "uploadAgain" : "อัปโหลดใหม่",
    "enterDesc" : "หากมีสิ่งที่ยืนยันว่าเป็นเจ้าของบัญชีได้ โปรดป้อนที่นี่",
    "contactEmail" : "อีเมล์",
    "applyNoteAttr" : "หมายเหตุ:",
    "applyNoteDate" : "โปรดป้อนอีเมลที่สามารถรับข้อมูลได้ทันท่วงที เพื่อความรวดเร็วในการแจ้งผลลัพธ์และความคืบหน้า",
    "agree" : "ฉันได้ยินยอม",
    "UJOYTerms" : "เงื่อนไขการให้บริการ UJOY",
    "privacy" : "นโยบายความเป็นส่วนตัว",
    "reviewStatusOfAccountFix" : "ความคืบหน้า",
    "enterReviewID" : "โปรดป้อนรหัสการเช็ค",
    "enterReviewPwd" : "โปรดป้อนรหัสผ่านการเช็ค",
    "review" : "เช็ค",
    "reviewNoteAttr" : "หมายเหตุ:",
    "reviewNoteData" : "หากท่านทำรหัสหรือรหัสผ่านการเช็คสูญหาย สามารถเช็คดูได้ในอีเมลของท่าน",
    "haveResetInfo" : "ท่านรีเซ็ตข้อมูลของท่านแล้ว!",
    "resetProfile" : "รีเซ็ตข้อมูลของท่าน",
    "desc" : "ยินดีด้วย ผ่านการอนุมัติแล้ว โปรดรีเซ็ตข้อมูลของท่าน!",
    "changePwd" : "แก้ไขรหัสผ่าน",
    "resetPwd" : "แก้ไขรหัสผ่านใหม่",
    "reset" : "แก้ไข",
    "enterNewPwd" : "โปรดป้อนรหัสผ่านใหม่",
    "confirmNewPwd" : "โปรดป้อนรหัสผ่านใหม่อีกครั้ง",
    "successResetPwd" : "ท่านตั้งค่ารหัสผ่านใหม่สำเร็จแล้ว",
    "bindSecurityEmail" : "ผูกมัดอีเมลยืนยัน",
    "resetPwdDesc" : "ใช้รีเซ็ตรหัสผ่านเมื่อลืมรหัสผ่านหรือบัญชีถูกแบน",
    "bindCommon" : "ผูกมัด",
    "sendCommon" : "ส่ง",
    "enterVcode" : "โปรดป้อนรหัสยืนยันที่ได้รับ",
    "successResetEmail" : "ท่านรีเซ็ตอีเมล์ยืนยันสำเร็จแล้ว",
    "resetQuest" : "รีเซ็ตคำถามยืนยัน",
    "resetQuestDesc" : "ใช้รีเซ็ตรหัสผ่านเมื่อลืมรหัสผ่านหรือบัญชีถูกแบน",
    "successResetQuest" : "ท่านรีเซ็ตคำถามยืนยันสำเร็จแล้ว",
    "hide" : "ซ่อน",
    "addRegisterTime" : "เพิ่มข้อมูลเวลาที่สมัคร;",
    "modelNum" : "โปรดป้อนระบบที่ใช้บ่อย:IDFA/GPID",
    "registrationIP" : "เพิ่มข้อมูล IP ที่ใช้สมัครบัญชี;",
    "addRechargeRecord" : "เพิ่มประวัติการเติมเงิน;",
    "serviceReply" : "ฝ่ายบริการลูกค้าตอบ:",
    "addDataLimitTime" : "เพิ่มเติมข้อมูลได้ถึง:",
    "addMoreInfo" : "เพิ่มเติมข้อมูล",
    "applicationSubmit" : "ยื่นเรื่องสำเร็จ",
    "underReviewStatus" : "เรากำลังอนุมัติข้อมูลของท่าน และจะติดต่อกลับภายใน 1 วันทำงาน ท่านสามารถเช็คความคืบหน้าได้โดย:",
    "reviewID" : "รหัสการเช็ค:",
    "reviePwd" : "รหัสผ่านการเช็ค:",
    "enterReviewIDNPwd" : "ป้อนรหัสการเช็คและรหัสผ่านการเช็คในหน้าเช็คความคืบหน้าการแก้ไขบัญชีก็จะทราบได้",
    "homepage" : "กลับหน้าหลัก",
    "checkEmailAttr" : "หมายเหตุ:",
    "checkEmailData" : "หากท่านทำรหัสหรือรหัสผ่านการเช็คสูญหาย สามารถเช็คดูได้ในอีเมลของท่าน",
    "underReview" : "กำลังตรวจสอบข้อมูล",
    "underReviewReply" : "กำลังอยู่ในช่วงตรวจสอบข้อมูล โปรดอดใจรอก่อน!",
    "failed" : "ไม่ผ่านการอนุมัติ",
    "reason" : "เนื่องจาก:### ที่ท่านแจ้งมา ทำให้ไม่ผ่านการอนุมัติ โปรดแจ้งข้อมูลที่ถูกต้องเพื่อให้เราจัดการโดยเร็วที่สุด",
    "underReviewAdd" : "กำลังตรวจสอบข้อมูล เพราะข้อมูลบางส่วนไม่ตรงกันหรือว่างเปล่า โปรดแจ้งข้อมูลเพิ่มเพื่อความสะดวกในการตรวจสอบ!",
    "addInfoRequired" : "ต้องเพิ่มเติมข้อมูล:",
    "dateForAddInfo" : "เพิ่มเติมข้อมูลได้ถึง:",
    "addInfo" : "เพิ่มเติมข้อมูล",
    "addInfoSubmit" : "เพิ่มเติมข้อมูลแล้ว โปรดรอการอนุมัติ!",
    "hasBeenRepaired" : "แก้ไขบัญชีเสร็จสิ้นแล้ว",
    "opExpired" : "หมดเวลาการแก้ไขบัญชีแล้ว",
    "approved" : "ผ่านการอนุมัติแล้ว",
    "haveSubmitted" : "ท่านเพิ่มเติมข้อมูลแล้ว",
    "sessionExpired" : "ท่านไม่ได้ล็อกอิน หรือ session หมดอายุ",
    "submitted" : "เพิ่มข้อมูลสำเร็จ",
    "addItemRegisterDate" : "เพิ่มข้อมูลอีเมลผูกมัด;",
    "addItemDeviceNumber" : "เพิ่มข้อมูลระบบปฏิบัติการที่ใช้บ่อย;",
    "reasonItemPwd" : "เลขบัตรประชาชนไม่สอดคล้อง;",
    "addItemIDPhoto" : "เพิ่มเอกสารยืนยันที่ชัดเจน;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "โปรดอัปโหลดสำเนาบัตรประชาชนที่มีขนาดไม่เกิน 20M",
    "uploadTipsBefore" : "โปรดอัปโหลดภาพที่มีขนาดไม่เกิน",
    "uploadTipsAfter" : "M",
    "submitError" : "เกิดความขัดข้อง เช่น ยังไม่ได้ป้อนเลขบัตรประชาชน หรือ บัญชีไม่ถูกต้อง",
    "applyLimitError" : "วันนี้ไม่มีสิทธิ์ยื่นเรื่องแล้ว",
    "applyDisabled" : "กำลังอยู่ในช่วงทำรายการ(ส่งได้ทุก 10 นาที)",
    "inputDataError" : "ข้อมูลไม่สมบูรณ์",
    "dataException" : "ข้อมูลขัดข้อง",
    "picSizeLimit" : "ไฟล์ต้องมีขนาดไม่เกิน 5M",
    "picTypeLimit" : "อัปโหลดได้เฉพาะ JPG PNG GIF",
    "picNull" : "ไม่มีภาพ",
    "alteredPassword" : "เคยแก้ไขรหัสผ่านแล้ว",
    "inputError" : "ป้อนไม่ถูกต้อง",
    "pwdChangefailed" : "แก้ไขรหัสผ่านไม่สำเร็จ",
    "sendEmailCodeDisabled" : "กำลังอยู่ในช่วงรอการส่งรหัสยืนยัน",
    "alteredEmail" : "เคยแก้ไขอีเมลแล้ว",
    "inputEmailError" : "อีเมลไม่ถูกต้อง",
    "operationFailed" : "ปฏิบัติไม่สำเร็จ",
    "codeNull" : "ท่านยังไม่ได้ป้อนรหัสยืนยัน",
    "findPwd" : "กู้รหัสผ่าน",
    "findAccountAndPwd" : "กู้บัญชี และรหัสผ่าน",
    "usualDeviceNum" : "ระบบบที่ใช้บ่อย:IDFA/GPID",
    "usualPhoneNum" : "รุ่นโทรศัพท์ที่ใช้บ่อย",
    "registerTimeError" : "เวลาที่สมัครไม่สอดคล้อง;",
    "bindEMailError" : "อีเมลผูกมัดไม่สอดคล้อง;",
    "rechargeRecordError" : "ประวัติเติมเงินไม่สอดคล้อง;",
    "registerIPError" : "IP ที่ใช้สมัครบัญชีไม่สอดคล้อง;",
    "deviceNumError" : "ระบบปฏิบัติการที่ใช้บ่อยไม่สอดคล้อง;",
    "deviceModelError" : "รุ่นอุปกรณ์ที่ใช้บ่อยไม่สอดคล้อง;",
    "confirmTerms" : "โปรดยินยอมในข้อตกลงการให้บริการ",
    "applyFixAccount" : "หากไม่สามารถยืนยันผ่านวิธีข้างต้น ท่านสามารถยื่นขอ<span>แก้ไขบัญชี</span>ได้",
    "findPwdByFixAccount" : "บัญชีนี้ไม่ได้ตั้งค่าอีเมล และคำถามยืนยัน โปรดกู้รหัสผ่านด้วยฟังก์ชั่นแก้ไขบัญชี",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "เพิ่มบุ๊กมาร์กในบราวเซอร์ เพื่อความรวดเร็วในการเล่นครั้งถัดไป~คุณรับรางวัลแล้ว",
    "h5_favour_get_gift" : "เพิ่มบุ๊กมาร์กในบราวเซอร์ เพื่อความรวดเร็วในการเล่นครั้งถัดไป~ส่งรางวัลเข้าอีเมลแล้ว",
    "h5_get_gift_fault" : "รับรางวัลไม่สำเร็จ โปรดลองใหม่ภายหลัง หรือติดตามฝ่ายบริการลูกค้าภายในเกม",
    "h5_favour_please_select" : "โปรดเลือกเซิร์ฟ/ตัวละคร",
    "h5_favour_login_get" : "โปรดเพิ่มบุ๊กมาร์กหลังเข้าเกม เพื่อให้รางวัลถูกส่งเข้าอีเมลของคุณ",
    "h5_favour_tip" : "เพิ่มบุ๊กมาร์กในบราวเซอร์ เพื่อความรวดเร็วในการเล่นครั้งถัดไป",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "สินค้าที่ท่านซื้อไม่สามารถซื้อได้ในช่องทางนี้ โปรดเปลี่ยนช่องทางซื้อ",
    "SwitchWithThirdWay" : "เปลี่ยนบัญชีล็อกอินเป็น \${type}",
    "moreGame" : "เกมมากขึ้น",
    "serviceTitle" : "ฝ่ายบริการลูกค้า",
    "h5_download_login" : "โปรดล็อกอินก่อน",
    "h5_download_tips" : "โปรดเปิดเกมจากหน้าเพจที่บันทึกไว้บนเดสก์ท็อป !",
    "h5_download_repeat_get" : "ท่านเคยรับรางวัลนี้แล้ว !",
    "h5_download_succ" : "โปรดบันทึกหน้าเพจไว้บนเดสก์ท็อปก่อน !",
    "h5_download_repeat_role" : "ตัวละครนี้ผูกมัดแล้ว",
    "currentLoginAccount" : "บัญชีที่ล็อกอินขณะนี้ :",
    "fb_canvas_fullscreen" : "โหมดเต็มหน้าจอ",
    "fb_canvas_website" : "เว็บไซต์",
    "fb_canvas_like_share" : "แชร์",
    "fb_canvas_service" : "บริการลูกค้า",
    "fb_canvas_login_fail" : "ล็อกอินล้มเหลว",
    "fb_canvas_pay_return" : "คุณได้ยกเลิกการซื้อขายในครั้งนี้แล้ว",
    "fb_canvas_root_tip" : "โปรดให้สิทธิ์การอนุุญาตล็อกอินผ่าน Facebook  ก่อน",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "กรุณาเลือกวิธีล็อกอิน",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "ได้ ท่านแน่ใจไหมว่าจะยกเลิกคำขอครั้งนี้ ?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "ท่านแน่ใจไหมว่าจะลบบัญชีนี้ และข้อมูลทั้งหมดภายในเกม ?",
    "account_delete_fwq" : "เซิร์ฟ",
    "account_delete_zhm" : "ชื่อตัวละคร",
    "account_delete_jshflj" : "กู้คืนตัวละคร",
    "account_delete_qzyzmdxx" : "(แบ่งตัวอักษระพิมพ์ใหญ่ และเล็ก)",
    "account_delete_jtbcysxx" : "แนะนำให้แคปเจอร์หน้าจอบันทึกข้อมูลข้างต้นเพื่อความสะดวกในการกู้คืนบัญชี !",
    "deleteaccount_step3_2" : "หลัง 14 วัน บัญชีจะถูกลบออกจากระบบถาวร และท่านก็จะไม่ได้รับการชดเชยใด ๆ\n\nภายใน 14 วันหลังยื่นคำขอ ท่านสามารถยกเลิกผ่าน",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "เติมเงิน",
    "h5_header_home_text" : "เว็บไซต์",
    "h5_check_gift_list_text" : "รางวัล",
    "yourServer" : "เซิร์ฟของท่าน",
    "allServer" : "เซิร์ฟทั้งหมด",
    "h5_header_screen" : "เต็มหน้าจอ",
    "h5_verticalTip" : "โปรดเล่นด้วยแนวนอน",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "เล่นล่าสุด",
    "moreGames" : "เกมส์อื่นๆ",
    "previousSelect" : "เลือกล่าสุด",
    "payAgainBtn" : "เติมอีกครั้ง",
    "packageTypeName" : "แพ็ครางวัล",
    "coinTypeName" : "เติมเงิน",
    "cardTypeName" : "บัตรรายเดือน",
    "orderNormal" : "อัตโนมัติ",
    "orderPriceUp" : "ราคาต่ำ-สูง",
    "orderPriceDown" : "ราคาสูง-ต่ำ",
    "returnSelectRole" : "กลับไปเลือกใหม่",
    "jiamaInfo" : "เกี่ยวกับโบนัสก้อนทอง/เพชร :\nโบนัสก้อนทอง/เพชร = ยอดเงินที่ผู้เล่นเติม*สัดส่วนก้อนทอง/เพชรของเกมส์*สัดส่วนโบนัส\n*หมายเหตุ : โบนัสก้อนทอง/เพชรไม่นับรวมในกิจกรรมเติมเงินภายในเกม และไม่สะสม EXP VIP\n*สำหรับเกมส์ที่ออนไลน์ทั่วโลก ยอดเงินที่ชำระจะเป็นสกุลดอลลาร์สหรัฐ หากท่านมีข้อสงสัย โปรดติดต่อฝ่ายบริการลูกค้า",
    "lastSelectTag" : "เลือกล่าสุด",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "การลบบัญชี",
    "apple_deleteaccount_title" : "แจ้งความจำนงลบบัญชี",
    "apple_deleteaccount_step1_1" : "โปรดอ่านรายละเอียดด้านล่างนี้ก่อน :",
    "apple_deleteaccount_step1_2" : "หลังท่านลบบัญชี บัญชีของท่านจะถูกฟรีซเป็นเวลา 14 วัน",
    "apple_deleteaccount_step1_3" : "หากหลัง 14 วันนี้ ท่านไม่ได้ยกเลิกการลบบัญชี บัญชีนี้ของท่าน จะถูกลบถาวร หลังถูกลบถาวร ท่านจะไม่สามารถใช้บัญชีนี้ล็อกอินเกมส์ได้อีก อีกทั้งข้อมูลทั้งหมดจะถูกลบ และไม่สามารถกู้คืนได้",
    "apple_deleteaccount_step1_4" : "หากท่านต้องการยกเลิกการผูกมัดกับบัญชีโซเชียลที่ได้ผูกมัดไว้ก่อนหน้านี้ โปรดติดต่อฝ่ายบริการลูกค้า เพื่อยกเลิกการผูกมัด แล้วถึงทำการลบบัญชี มิเช่นนั้น หลังลบบัญชี บัญชีโซเชียลที่ท่านผูกมัดไว้ก่อนหน้านี้ ก็จะไม่สามารถล็อกอินได้เช่นกัน",
    "apple_deleteaccount_step1_5" : "หากต้องการขอคืนเงิน ก็โปรดติดต่อฝ่ายบริการลูกค้าก่อนลบเช่นกัน และก่อนทำการลบบัญชี โปรดตรวจสอบให้แน่ใจว่าท่านได้จัดแจงกับทรัพยากรต่างๆ ภายในเกมส์เรียบร้อยแล้ว",
    "apple_deleteaccount_step1_6" : "ในระหว่างที่บัญชีถูกฟรีซ ท่านสามารถยกเลิกความจำนงลบบัญชีผ่านลิงก์ด้านล่างนี้ได้ (โปรดบันทึกลิงก์นี้ไว้เพื่อความสะดวกในการค้นหา)",
    "apple_deleteaccount_step2_1" : "ท่านจัดแจงทรัพยากรภายในเกมส์เรียบร้อยแล้วหรือไม่? หากยัง โปรดติดต่อฝ่ายบริการลูกค้า แล้วจึงแจ้งความจำนงลบบัญชีใหม่",
    "apple_deleteaccount_step2_2" : "โปรดเก็บรักษาข้อมูลของเซิร์ฟเวอร์ และตัวละครของท่านไว้ เพราะนี่เป็นหลักฐานเดียวที่ใช้ในการกู้บัญชี :",
    "apple_deleteaccount_step2_3" : "โปรดป้อน “Delete”เพื่อทำการลบ",
    "apple_deleteaccount_step3_1" : "ท่านแจ้งความจำนงขอลบบัญชีแล้ว บัญชีด้านล่างนี้ ได้ถูกฟรีซแล้ว :",
    "apple_deleteaccount_step3_2" : "ระบบจะฟรีซบัญชีข้างต้นเป็นเวลา 14 วัน หากท่านไม่ได้แจ้งความจำนงขอยกเลิก เราจะลบบัญชีนี้ถาวร",
    "apple_deleteaccount_step3_3" : "ภายใน 14 วันนี้ ท่านยังสามารถยกเลิกการลบบัญชีผ่านลิงก์ด้านล่างได้",
    "apple_deleteaccount_step4_1" : "ท่านได้ลบบัญชีเก่าแล้ว ในการเข้าครั้งหน้า จะใช้บัญชีใหม่ล็อกอิน",
    "apple_deleteaccount_agree" : "ฉันได้อ่าน และยินยอมในเนื้อหาข้างต้นแล้ว",
    "apple_deleteaccount_server" : "เซิร์ฟเวอร์",
    "apple_deleteaccount_roleName" : "ชื่อตัวละคร",
    "copyLink" : "คัดลอกลิงก์",
    "copyTextAndImg" : "โปรดคัดลอก หรือแคปหน้าจอ เพื่อบันทึก",
    "copyLinkAndRoleInfo" : "คัดลอกลิงก์ และชื่อตัวละคร",
    "hasCopy" : "คัดลอกไปยังคลิปบอร์ดแล้ว",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "If you chose to save your card number on the previous page, we would collect the data of your card  (**** **** **** 1234) in encrypted version.",
    "quickcard_result_tip_two" : "We store encrypted details only for your convenience, and you do not have to input card numbers at your next purchase.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Stored Credentials Statements",
    "quickcard_info_tip_one" : "To better protect customer data security, Visa and Mastercard are introducing new definitions for these \"stored credentials\", and new rules for stored credential and merchant initiated transactions.",
    "quickcard_info_tip_two" : "When you make a purchase on our website, we collect the data of your card (1234 **** **** 1234) in encrypted version. We will hold the encrypted details for 4 years and will update the agreement, privacy policy on our website in case there are any changes. We store encrypted details only for your convenience, and you do not have to input card numbers at your next purchase.",
    "search_product" : "ค้นหาชื่อ",
    "search_price" : "ค้นหาชื่อ,ราคาสินค้า",
    "price" : "ค้นหราคาสินค้า",
    "product_no_found" : "ขออภัย ไม่พบชื่อ/ราคาสินค้าที่สอดคล้อง",
    "price_no_found" : "ขออภัย ไม่พบชื่อ/ราคาสินค้าที่สอดคล้อง",
    "search_no_found" : "ขออภัย ไม่พบชื่อ/ราคาสินค้าที่สอดคล้อง",
    "product" : "ชื่อ",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "โปรดเลือกตัวละครที่ต้องการเติมเงิน",
    "storeSocialLogin" : "ใช้บัญชีโซเชียล",
    "storeAccountIdLogin" : "ใช้บัญชี ID",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "เช็ค",
    "storeSelectProductTitle" : "โปรดเลือกไอเทมที่ต้องการซื้อ",
    "storeInputNameSearch" : "ป้อนชื่อไอเทมเพื่อค้นหา",
    "storeInputPriceSearch" : "ป้อนราคาไอเทมเพื่อค้นหา",
    "storeNoFindProduct" : "ไม่พบไอเทมนี้ โปรดค้นหาอีกครั้ง",
    "storePriceUp" : "ราคาต่ำ-สูง",
    "storePriceDown" : "ราคาสูง-ต่ำ",
    "storeLookDetail" : "ดูเพิ่มเติม",
    "storeChangeProduct" : "เปลี่ยนไอเทม",
    "storeWelcome" : "ยินดีต้อนรับ",
    "storeLookMore" : "ดูเพิ่มเติม",
    "storeHasSelect" : "ไอเทมที่เลือกแล้ว",
    "storeTotal" : "รวม",
    "storeExtra" : "แจกเพิ่ม",
    "storeProductDetail" : "รายละเอียด",
    "storeUidGuideStep1" : "แตะ「ตั้งค่า」-「เพิ่มเติม」-「บัญชี」",
    "storeUidGuideStep2" : "ป้อน「ID บัญชี」นี้ ก็สามารถเติมเงินได้",
    "storeSelectAndLook" : "โปรดเลือกตัวละครเพื่อค้นหาไอเทม",
    "storeSwitchWay" : "เปลี่ยนวิธีล็อกอิน",
    "type1" : "โปรโมชั่นรายวัน",
    "type2" : "ฮีโร่",
    "type3" : "อุปกรณ์สู้รบ",
    "type4" : "",
    "type5" : "ชิป",
    "type6" : "มิวแทนท์",
    "type7" : "ทรัพยากร",
    "type8" : "เร่งสปีดก่อสร้าง",
    "type9" : "แรร์ไอเทม",
    "type10" : "สมาพันธ์",
    "type11" : "เพชร",
    "type12" : "อะไหล่",
    "type13" : "รูบิก",
    "type14" : "",
    "type15" : "อาวุธนาโน",
    "type16" : "รางวัลใหญ่",
    "type17" : "",
    "type9999" : "จำนวนจำกัด",
    "type10000" : "ศูนย์สวัสดิการ",
    "type10001" : "กิจกรรมเทศกาล",
    "typeother" : "สินค้าอื่น ๆ",
    "switchChar" : "เปลี่ยนตัวละคร",
    "howToFindUid" : "เช็ค ID บัญชีได้จากที่ใด?",
    "choosePayWay" : "โปรดเลือกวิธีชำระเงิน",
    "new_apple_deleteaccount_stepsub_title" : "ยกเลิกต่ออายุสมาชิกอัตโนมัติ",
    "new_apple_deleteaccount_stepsub_1" : "ระบบพบว่าบัญชีของท่านมีรายการชำระเงินของการต่ออายุสมาชิกอัตโนมัติ แนะนำให้ท่านยกเลิกสถานะสมาชิกก่อนลบบัญชี เพื่อเลี่ยงจากการถูกหักค่าใช้จ่ายต่อหลังลบบัญชี",
    "new_apple_deleteaccount_stepsub_2" : "ยกเลิกต่ออายุสมาชิกอัตโนมัติ",
    "new_apple_deleteaccount_stepsub_later" : "ลบภายหลัง",
    "new_apple_deleteaccount_stepsub_now" : "ลบทันที",
    "new_apple_deleteaccount_title" : "ยื่นคำขอลบบัญชี",
    "new_apple_deleteaccount_step1_1" : "โปรดอ่านเนื้อหาด้านล่างนี้อย่างละเอียด :",
    "new_apple_deleteaccount_step1_2" : "หลังท่านทำการลบบัญชี เราจะ<span class=\"highlight\">ลบบัญชีนี้ของท่านอย่างถาวร</span> หลังจากนั้น ท่านจะไม่สามารถใช้บัญชีนี้ล็อกอินเกมส์ ขณะเดียวกัน ข้อมูลผู้ใช้งานทั้งหมดก็จะถูกลบ และไม่สามารถกู้คืนด้วย",
    "new_apple_deleteaccount_step1_3" : "หากท่านต้องการปลดการผูกมัดกับบัญชีโซเชียลอื่นๆ ที่ก่อนหน้านี้ผูกมัดไว้ โปรดติดต่อฝ่ายบริการลูกค้าล่วงหน้า เพื่อปลดการผูกมัดให้เสร็จสิ้นก่อนลบบัญชี มิเช่นนั้น หลังบัญชีถูกลบ ท่านก็ไม่สามารถใช้บัญชีโซเชียลเหล่านั้นล็อกอินได้อีก",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">หากต้องการขอคืนเงิน ก็โปรดติดต่อฝ่ายบริการลูกค้าก่อนทำการลบเช่นกัน</span> ก่อนทำการลบบัญชี โปรดตรวจสอบว่าทรัพยากรภายในเกมส์ของท่าน ได้ทำการจัดแจงเรียบร้อยแล้ว",
    "new_apple_deleteaccount_step2_1" : "ท่านจัดแจงทรัพยากรภายในเกมส์ของท่านเรียบร้อยแล้วหรือยัง ? หากยัง โปรดติดต่อฝ่ายบริการลูกค้าก่อน",
    "new_apple_deleteaccount_step2_2" : "โปรดป้อน“Delete”ในกรอบ เพื่อทำการลบ หลังยื่นคำขอ บัญชีของท่านจะไม่สามารถกู้คืนได้",
    "new_apple_deleteaccount_step2_3" : "โปรดป้อน “Delete”เพื่อทำการลบ",
    "new_apple_deleteaccount_step3_1" : "ท่านยื่นคำขอลบบัญชีแล้ว บัญชี และข้อมูลผู้ใข้งานด้านล่างนี้ได้ถูกลบออกจากระบบอย่างถาวร :",
    "new_apple_deleteaccount_step3_2" : "หากท่านยังคงต้องการล็อกอินเกมส์ โปรดสมัครบัญชีใหม่",
    "new_apple_deleteaccount_step4_1" : "ท่านลบบัญชีเก่าแล้ว ในการเข้าครั้งหน้า จะล็อกอินด้วยบัญชีใหม่",
    "currencyTypeName" : "สกุลเงินดิจิทัล",
    "has_select_product" : "สินค้าที่เลือกแล้ว :",
    "n_product" : "\${n} ชิ้น",
    "look_detail_product" : "ดูทั้งหมด",
    "limit_buy_product" : "ซื้อสินค้านี้ได้ \${n} ชิ้น",
    "limit_order" : "ซื้อได้สูงสุด \${n} ชิ้น ต่อการสั่งซื้อ 1 ครั้ง",
    "limit_order_remove_tip" : "การสั่งซื้อครั้งนี้มีสินค้าที่จำกัดการซื้อ ต้องการลบออกจากรถเข็นไหม?",
    "paytype_limit" : "สินค้าบางส่วนไม่สนับสนุนการชำระเงินด้วยช่องทางนี้ โปรดชำระเงินด้วยช่องทางอื่น หรือ ซื้อแยก",
    "check_remove_cart" : "ต้องการลบออกจากรถเข็นไหม?",
    "remove_cart" : "ลบออก",
    "confirm_product" : "ยืนยัน",
    "select_paytype" : "เลือกช่องทางชำระเงิน",
    "cart_is_empty_tip" : "รถเข็นว่างเปล่า โปรดเลือกสินค้าก่อน",
    "thirty_tip" : "หากไม่ได้รับสินค้าภายใน 30 นาที โปรดติดต่อเรา",
    "total_n_product" : "สินค้า \${n} ชิ้น",
    "look_detail_of_cart" : "ดูรายละเอียด",
    "order_detail" : "ประวัติออเดอร์สินค้าเติมเงิน",
    "total_detail" : "จำนวน :",
    "add_to_cart" : "ใส่รถเข็น",
    "back_to_select" : "กลับไปเลือกใหม่",
    "fail_and_later" : "ข้อมูลสินค้าไม่ถูกต้อง โปรดลองใหม่ภายหลัง",
    "nextStep" : "ยืนยัน",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "เข้าสู่เว็บไซต์",
    "visitorLogin" : "ผู้เยี่ยมชมล็อกอิน",
    "tokenLogin" : "OTP",
    "fbLogin" : "Facebook ล็อกอิน",
    "googleLogin" : "Google ล็อกอิน",
    "twitterLogin" : "Twitter ล็อกอิน",
    "vkLogin" : "VK ล็อกอิน",
    "agreementTextStart" : "เมื่อล็อกอินเกม จะถือว่าคุณได้อ่านและยินยอมใน เงื่อนไขผู้ใช้งาน และ นโยบายความเป็นส่วนตัว",
    "userCenter" : "ศูนย์ผู้ใช้งาน",
    "welcomeBack" : "ยินดีต้อนรับกลับมา",
    "continueGame" : "เล่นต่อ",
    "officialPay" : "ศูนย์เติมเงิน",
    "changeAccount" : "เปลี่ยนบัญชี",
    "back" : "กลับ",
    "tokenKey" : "OTP",
    "inputUid" : "โปรดป้อน UID",
    "inputToken" : "โปรดป้อน OTP",
    "inputCkCode" : "โปรดป้อนรหัสยืนยัน",
    "enterGame" : "เข้าสู่เกม",
    "tokenTip" : "ใช้ OTP ปกป้องความปลอดภัยบัญชีของคุณ",
    "howToGetToken" : "สามารถรับ OTP ได้จาก?",
    "getStep1" : "Step1 : เลือกตั้งค่า-บัญชี-ศูนย์ผู้ใช้งาน",
    "getStep2" : "Step2 : เลือก OTP",
    "getStep3" : "Step3 : คัดลอก พร้อมป้อน UID และ OTP ของคุณ",
    "copy" : "คัดลอก",
    "lastRefresh" : "รีเฟรชครั้งถัดไป :",
    "second" : "s",
    "immediatelyRefresh" : "รีเฟรชทันที",
    "frequently" : "ทำรายการบ่อยเกินไป โปรดลองใหม่ภายหลัง",
    "loginFail" : "ล็อกอินไม่สำเร็จ เพราะรหัสยืนยันไม่ถูกต้อง",
    "tokenIntro" : "เกี่ยวกับการใช้ OTP :",
    "tokenIntro1" : "(1) รหัส OTP มีอายุการใช้งาน 120 วินาที สามารถคุ้มครองความปลอดภัยให้บัญชีของคุณได้",
    "tokenIntro2" : "(2) ทีมงานจะไม่ขอรับรหัส OTP จากคุณ และโปรดอย่าเปิดเผยให้ผู้อื่นทราบ",
    "nextStep1" : "ยืนยัน",
    "couponCanUse" : "คูปองที่ใช้ได้",
    "couponCanNotUse" : "คูปองที่ใช้ไม่ได้",
    "couponHasNoCoupon" : "ยังไม่มีคูปอง",
    "couponUseTip" : "*ใช้ได้การสั่งซื้อละ 1 ใบ",
    "couponValidTime" : "คูปองใช้ได้ระหว่าง",
    "couponFuilCanUse" : "ใช้ได้เมื่อครบ \${price} \${currency}",
    "couponNoLimit" : "ไม่มีเงื่อนไขการใช้",
    "couponAllProductCanUse" : "ใช้กับสินค้าทั้งหมดได้",
    "couponPartProductCanUse" : "ใช้ได้กับสินค้าบางส่วน",
    "couponPartPaytypeCanUse" : "ใช้ได้กับบางช่องทางชำระเงิน",
    "couponOnlyCoinCanUse" : "ใช้กับเหรียญในเกมได้เท่านั้น",
    "couponOnlyDiamondCanUse" : "ใช้กับเพชรได้เท่านั้น",
    "couponOnlyPackageCanUse" : "ใช้กับแพ็กได้เท่านั้น",
    "couponOnlySubCanUse" : "ใช้กับการสมัครสมาชิกได้เท่านั้น",
    "couponOnlyDaibiCanUse" : "ใช้กับเหรียญแทนเงินสดได้เท่านั้น",
    "couponMaxDiscount" : "ได้รับส่วนลดสูงสุด \${price} \${currency}",
    "couponHasUsed" : "ใช้ไปเมื่อ",
    "couponReductionType" : "คูปองส่วนลดเมื่อครบยอด",
    "couponDiscountType" : "คูปองส่วนลด",
    "couponUseNow" : "ใช้เลย",
    "couponHasNoSelect" : "ยังไม่ได้เลือกคูปอง",
    "couponHasSelectQuan" : "เลือกแล้ว",
    "couponSubmitTip" : "*หลังส่งการสั่งซื้อ จะใช้คูปองทันที",
    "couponCanUseQuan" : "คูปองที่ใช้ได้",
    "couponOrderTotal" : "ยอดการสั่งซื้อ",
    "couponHasDiscount" : "ลดแล้ว",
    "couponPayTotal" : "ยอดชำระเงิน",
    "couponCancel" : "ยกเลิก",
    "couponConfirm" : "ยืนยัน",
    "uidLoginName" : "ล็อกอินด้วย OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "โปรดป้อน UID",
    "uidInputToken" : "โปรดป้อน OTP",
    "uidInputCode" : "โปรดป้อนรหัสยืนยัน",
    "uidTipTitle" : "ใช้ OTP ปกป้องความปลอดภัยบัญชีของคุณ",
    "uidTipHowToGet" : "สามารถรับ OTP ได้จาก?",
    "uidTipStep1" : "Step1 : เลือกตั้งค่า-บัญชี-ศูนย์ผู้ใช้งาน",
    "uidTipStep2" : "Step2 : เลือก OTP",
    "uidTipstep3" : "Step3 : คัดลอก พร้อมป้อน UID และ OTP ของคุณ",
    "uidTipIntro1" : "(1) รหัส OTP มีอายุการใช้งาน 60 วินาที สามารถคุ้มครองความปลอดภัยให้บัญชีของคุณได้",
    "uidTipIntro2" : "(2) ทีมงานจะไม่ขอรับรหัส OTP จากคุณ และโปรดอย่าเปิดเผยให้ผู้อื่นทราบ",
    "couponMyQuan" : "คูปองของฉัน",
    "couponSelectPaytypeTip" : "ยืนยันส่วนลดเมื่อเลือกช่องทางชำระเงิน",
    "couponSelectCouponTip" : "เช็คราคาหลังลดเมื่อเลือกคูปอง",
    "couponValidQuanTip" : "(มีคูปองที่ใช้ได้ \${num} ใบ)",
    "couponLookCart" : "ดูรถเข็น",
    "couponUnfoldCart" : "ซ่อนรถเข็น",
    "couponCoupon" : "คูปอง",
    "couponNoUse" : "ยังไม่ได้ใช้",
    "couponSelect" : "เลือกคูปอง",
    "couponSureUse" : "ยืนยันใช้",
    "couponReturn" : "กลับ",
    "couponInvalidTime" : "คูปองหมดอาย",
    "couponBuyNow" : "ซื้อทันที",
    "couponAllType" : "all",
    "ztmslgType1" : "โปรโมชั่นรายวัน",
    "ztmslgType2" : "ฮีโร่",
    "ztmslgType3" : "อุปกรณ์สู้รบ",
    "ztmslgType4" : "",
    "ztmslgType5" : "ชิป",
    "ztmslgType6" : "มิวแทนท์",
    "ztmslgType7" : "ทรัพยากร",
    "ztmslgType8" : "เร่งสปีดก่อสร้าง",
    "ztmslgType9" : "แรร์ไอเทม",
    "ztmslgType10" : "สมาพันธ์",
    "ztmslgType11" : "เพชร",
    "ztmslgType12" : "อะไหล่",
    "ztmslgType13" : "รูบิก",
    "ztmslgType14" : "",
    "ztmslgType15" : "อาวุธนาโน",
    "ztmslgType16" : "รางวัลใหญ่",
    "ztmslgType17" : "แก่นผลึก",
    "ztmslgType9999" : "จำนวนจำกัด",
    "ztmslgType10000" : "ศูนย์สวัสดิการ",
    "ztmslgType10001" : "กิจกรรมเทศกาล",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "โปรฯรายวัน",
    "antslgType2" : "มดพิเศษ",
    "antslgType3" : "Gear",
    "antslgType5" : "ยีน",
    "antslgType6" : "หอยทาก",
    "antslgType7" : "ทรัพยากร",
    "antslgType8" : "สร้างวิจัย",
    "antslgType9" : "แรร์ไอเทม",
    "antslgType10" : "พันธมิตร",
    "antslgType11" : "เพชร",
    "antslgType12" : "เซลล์",
    "antslgType13" : "โทเทม",
    "antslgType9999" : "ลิมิเต็ด",
    "antslgTypeother" : "other",
    "typeall" : "ทั้งหมด",
    "vipHead" : "พอยท์ VIP",
    "vipHead213": "สมาชิก VIP",
    "vipTitle" : "กิจกรรมพอยท์ VIP",
    "nowLevel" : "ขณะนี้เป็น VIP:",
    "myVipScore" : "ฉันมีพอยท์:",
    "nextLevelNeed" : "(อีก \${num} พอยท์ จะอัปเกรดเป็น VIP \${level})",
    "ruleTitle" : "กติกา:",
    "ztmslgVipRule1" : "1.ระยะเวลากิจกรรม : 22 ก.ย. 2022 เวลา 00:00 น.เป็นต้นไป (UTC)",
    "ztmslgVipRule2" : "2.เกมที่ร่วมกิจกรรม :  Puzzles & Survival",
    "ztmslgVipRule3" : "กิจกรรมแต่ละประเภท สามารถรับรางวัลได้เพียง 1 ครั้ง",
    "ztmslgVipRule4" : "3. กิจกรรม \"ล็อกอินแจกคูปอง\" : เปิดหน้าเติมเงินครั้งแรก รับคูปองลด 15%",
    "ztmslgVipRule5" : "4.กิจกรรม \"พอยท์ VIP\" : เมื่อพอยท์จากการซื้อสินค้าในหน้าชำระเงินทางการถึงเลเวลที่กำหนด จะสามารถรับคูปองและคูปองพิเศษประจำสัปดาห์ของเลเวลที่ถึงได้",
    "ztmslgVipRule6" : "5.อัตราพอยท์ของแต่ละสกุลเงินสามารถดูได้ในตาราง 1 หากถึงไม่ถึง 1 พอยท์ จะไม่นับ",
    "ztmslgVipRule7" : "6.หากการสั่งซื้อใช้คูปอง พอยท์จะถูกคำนวณตามยอดการชำระแท้จริง",
    "ztmslgVipRule8" : "7.พอยท์มีอายุ 365 วัน และเลเวล VIP จะเปลี่ยนแปลงตามพอยท์ปัจจุบันที่เป็นผล",
    "ztmslgVipRule9" : "8.เมื่อถึง VIP ที่กำหนด ก็สามารถรับคูปองที่ถึงในครั้งแรก และคูปองประจำสัปดาห์ของเลเวลใหม่ จากนั้น จะแจกคูปองประจำสัปดาห์ทุกสัปดาห์ ในเวลาเที่ยงคืนของทุกวันเสาร์ (UTC+0)",
    "ztmslgVipRule10" : "9.ในการรับคูปองประจำสัปดาห์ จะต้องล็อกอิน หากไม่มารับ จะไม่ชดเชยให้ และคูปองจะอัปเดตในเวลาที่กำหนด",
    "ztmslgVipRule11" : "10.สกุลเงินของคูปองจะยึดสกุลเงินของออร์เดอร์เติมเงินสุดท้ายของคุณเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อเรา",
    "ztmslgVipRule12" : "11.ระดับ VIP และคูปองที่แจก มีดังนี้ :",
    "ztmslgVipRule13" : "12.ทีมงาน  Puzzles & survival  ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกา เงื่อนไข รวมถึงข้อกำหนดในกิจรรมนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "vipLevel" : "ระดับ VIP",
    "vipCondition" : "เงื่อนไขพอยท์",
    "firstSend" : "เมื่อถึงเป็นครั้งแรก แจก",
    "weeklySend" : "คูปองประจำสัปดาห์",
    "lastAllCoupon" : "คูปองทั้งหมดของระดับที่แล้ว",
    "besides" : "ตารางแนบ :",
    "couponRatio" : "อัตราสกุลเงินต่างๆ และพอยท์ VIP",
    "backToPay" : "กลับไปเติมเงิน",
    "quanGift" : "คูปองโบนัส",
    "quanGiftTips" : "คุณมีคูปองใหม่ดังที่แนบมา",
    "antslgVipRule1" : "เนื่องจากเปลี่ยนฟังก์ชั่นใหม่ กิจกรรม “แต้ม VIP” เดิมจะสิ้นสุดลง",
    "antslgVipRule2" : "ขอให้คุณใช้ตั๋วโปรที่ได้รับจากกิจกรรม “แต้ม VIP” เดิมภายในเวลา เพื่อหลีกเลี่ยงตั๋วโปรหมดอายุ",
    "antslgVipRule3" : "เวลาสิ้นสุด:2024-09-28 เวลา 00:00:00 น.(utc)",
    "antslgVipRule4" : "หลังสิ้นสุดกิจกรรม คุณสามารถไปศูนย์สมาชิกเพื่อรับสิทธิประโยชน์มากมาย:",
    "antslgVipRule5" : "เคลียร์เควสรับแต้ม ใช้แต้ม จะสามารถแลกตั๋วโปร ไอเทมเกมและรางวัลอื่นๆ! ยังมีสิทธิประโยชน์สมาชิกพิเศษ จับรางวัลแต้มและกิจกรรมโบนัสอื่นๆ",
    "antslgVipRule6" : "โปรดอดใจรอก่อน",
    "dzgVipRule0" : "1.ระยะเวลากิจกรรม : 27 ก.ย. 2022 เวลา 00:00 น.เป็นต้นไป (UTC)",
    "dzgVipRule1" : "1.เกมที่ร่วมกิจกรรม :  \${gameName}",
    "dzgVipRule2" : "กิจกรรมแต่ละประเภท สามารถรับรางวัลได้เพียง 1 ครั้ง",
    "dzgVipRule3" : "2. กิจกรรม \"ล็อกอินแจกคูปอง\" : เปิดหน้าเติมเงินครั้งแรก รับคูปองลด 15%",
    "dzgVipRule4" : "3.กิจกรรม \"พอยท์ VIP\" : เมื่อพอยท์จากการซื้อสินค้าในหน้าชำระเงินทางการถึงเลเวลที่กำหนด จะสามารถรับคูปองและคูปองพิเศษประจำสัปดาห์ของเลเวลที่ถึงได้",
    "dzgVipRule5" : "4.อัตราพอยท์ของแต่ละสกุลเงินสามารถดูได้ในตาราง 1 หากถึงไม่ถึง 1 พอยท์ จะไม่นับ",
    "dzgVipRule6" : "5.หากการสั่งซื้อใช้คูปอง พอยท์จะถูกคำนวณตามยอดการชำระแท้จริง",
    "dzgVipRule7" : "6.พอยท์มีอายุ 365 วัน และเลเวล VIP จะเปลี่ยนแปลงตามพอยท์ปัจจุบันที่เป็นผล",
    "dzgVipRule8" : "7.เมื่อถึง VIP ที่กำหนด ก็สามารถรับคูปองที่ถึงในครั้งแรก และคูปองประจำสัปดาห์ของเลเวลใหม่ จากนั้น จะแจกคูปองประจำสัปดาห์ทุกสัปดาห์ ในเวลาเที่ยงคืนของทุกวันเสาร์ (UTC+0)",
    "dzgVipRule9" : "8.ในการรับคูปองประจำสัปดาห์ จะต้องล็อกอิน หากไม่มารับ จะไม่ชดเชยให้ และคูปองจะอัปเดตในเวลาที่กำหนด",
    "dzgVipRule10" : "9.สกุลเงินของคูปองจะยึดสกุลเงินของออร์เดอร์เติมเงินสุดท้ายของคุณเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อเรา",
    "dzgVipRule11" : "10.ระดับ VIP และคูปองที่แจก มีดังนี้ :",
    "dzgVipRule12" : "11.ทีมงาน  \${gameName}  ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกา เงื่อนไข รวมถึงข้อกำหนดในกิจรรมนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "213dzgVipRule1" : "เนื่องจากเปลี่ยนฟังก์ชั่นใหม่ กิจกรรม “แต้ม VIP” เดิมจะสิ้นสุดลง",
    "213dzgVipRule2" : "ขอให้คุณใช้ตั๋วโปรที่ได้รับจากกิจกรรม “แต้ม VIP” เดิมภายในเวลา เพื่อหลีกเลี่ยงตั๋วโปรหมดอายุ",
    "213dzgVipRule3" : "เวลาสิ้นสุด:2024-08-19 เวลา 08:00:00 น.(utc)",
    "213dzgVipRule4" : "หลังสิ้นสุดกิจกรรม คุณสามารถไปศูนย์สมาชิกเพื่อรับสิทธิประโยชน์มากมาย:",
    "213dzgVipRule5" : "เคลียร์เควสรับแต้ม ใช้แต้ม จะสามารถแลกตั๋วโปร ไอเทมเกมและรางวัลอื่นๆ! ยังมีสิทธิประโยชน์สมาชิกพิเศษ จับรางวัลแต้มและกิจกรรมโบนัสอื่นๆ",
    "213dzgVipRule6" : "โปรดอดใจรอก่อน",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "ผูกมัด/ปลดการผูกมักบัญชี",
    "unbindApply" : "ยื่นปลดการผูกมัด",
    "unbindConfirmTitle" : "ยืนยันปลดการผูกมัดไหม?",
    "unbindConfirmTip" : "ท่านแน่ใจไหมว่าจะปลดการผูกมัดกับบัญชีที่ 3? นี่อาจทำให้ความคืบหน้าของบัญชีหายไป",
    "unbindConfirm" : "ใช่ ปลดการผูกมัดต่อ",
    "unbindExit" : "ไม่ ออก",
    "unbindSucc" : "ปลดการผูกมัดสำเร็จ",
    "unbindFail" : "ปลดการผูกมัดไม่สำเร็จ โปรดติดต่อฝ่ายบริการลูกค้า",
    "unbindServiceTitle" : "ยื่นปลดการผูกมัดผ่านฝ่ายบริการลูกค้า",
    "unbindContact" : "ติดต่อฝ่ายบริการลูกค้า",
    "unbindServiceTip" : "คุณไม่สอดคล้องเงื่อนไขปลดการผูกมัดอัตโนมัติ หรือยื่นปลดการผูกมัดผ่านฝ่ายบริการลูกค้า",
    "antslgType15" : "Legacy",
    "shareEventTitle" : "เชิญเพื่อน รับรางวัล",
    "shareRule" : "กติกา",
    "awardBag" : "เป้รางวัลของฉัน",
    "initiatorText" : "ฉันคือผู้เชิญ",
    "inviteeText" : "ฉันคือผู้ถูกเชิญ",
    "createCode" : "สร้างโค้ดเชิญ",
    "createCodeTip" : "แตะเพื่อสร้างโค้ดเชิญของท่าน",
    "createLinkTip" : "แตะเพื่อสร้างลิงก์เชิญของท่าน",
    "copyText" : "คัดลอก",
    "shareCode" : "แชร์โค้เชิญ",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "เช็ครางวัล",
    "seeAwardTip" : "สามารถเช็คและใช้ได้ใน \"<span class=\'see-light\'>พอยท์ VIP</span>\" - \"<span class=\'see-light\'>คูปองของฉัน</span>\"",
    "inviteReward" : "รางวัลการเชิญ",
    "inviteRewardTip" : "ระบบจะไม่รีเซ็ตระดับการเติมเงินสะสมของผู้ถูกเชิญ",
    "overweightReward" : "รางวัลโบนัส",
    "resetTip" : "รีเซ็ตทุกวันสุดท้ายของเดือน เวลา 00:00 น.",
    "rewardText1" : "ผู้ถูกเชิญเติมเงินสะสมครบ 9.99 USD",
    "rewardText2" : "ผู้ถูกเชิญเติมเงินสะสมครบ 49.99 USD",
    "rewardText3" : "ผู้ถูกเชิญเติมเงินสะสมครบ 99.99 USD",
    "rewardText4" : "ทุกเชิญ 5 คน จะได้รับคูปองลด 12% จำนวน 1 ใบ!",
    "rewardText5" : "ผูุู้กเชิญเติมเงินสะสมครบ 1,000 USD จะได้รับคูปองลด 15% จำนวน 1 ใบ!",
    "invitationList" : "การเชิญ",
    "refresh" : "รีเฟรช",
    "invitedTotal" : "ขณะนี้เชิญแล้ว : \${total} คน",
    "storedTotal" : "ขณะนี้เติมเงินสะสมแล้ว : \${total} USD",
    "people" : "",
    "invitedPeople" : "ผู้ถูกเชิญ",
    "invitedTime" : "รับการเชิญเมื่อ",
    "got" : "ครบแล้ว",
    "get" : "สำเร็จแล้ว",
    "overlay" : "ใช้พร้อมกันได้",
    "couponText" : "คูปอง",
    "personalReward" : "รางวัลผู้เล่นเติมเงินสะสม",
    "personalRewardText1" : "ผู้เล่นเติมเงินสะสมครบ 9.99 USD",
    "personalRewardText2" : "ผู้เล่นเติมเงินสะสมครบ 49.99 USD",
    "personalRewardText3" : "ผู้เล่นเติมเงินสะสมครบ 99.99 USD",
    "inputCode" : "ป้อนโค้ดเชิญ",
    "bindCode" : "ผูกมัดโค้ดเชิญ",
    "bindSucc" : "ผูกมัดแล้ว",
    "codeTip1" : "ไม่มีโค้ดเชิญนี้ โปรดป้อนใกม่",
    "codeTip2" : "ผูกมัดโค้ดเชิญแล้ว",
    "copySucc" : "คัดลอกสำเร็จ",
    "awardName" : "ชื่อรางวัล",
    "getTime" : "ได้รับเมื่อ",
    "getCondition" : "เงื่อนไข",
    "couponText1" : "คูปองลด 6%",
    "couponText2" : "คูปองลด 8%",
    "couponText3" : "คูปองลด 10%",
    "couponText4" : "คูปองลด 12%",
    "couponText5" : "คูปองลด 15%",
    "ruleText1" : "1.ระยะเวลา : 25 พ.ย. 2022 เวลา 00:00 น.เป็นต้นไป (UTC)",
    "ruleText2" : "2.เกมที่ร่วมกิจกรรม : Puzzles & Survival",
    "ruleText3" : "3.กิจกรรม \"แชร์ทันทีมีรางวัล\" : แชร์และเชิญเพื่อนมาเติมเงินผ่านเว็บไซต์ทางการครบยอดที่กำหนด สามารถรับรางวัลได้",
    "ruleText4" : "4.กิจกรรม \"รางวัลแชร์รายเดือน\" : หลังบรรลุเป้าหมายการแชร์ของแต่ละเดือน สามารถรับรางวัลได้ และรางวัลจะรีเฟรชทุกเดือน",
    "ruleText5" : "5.รับรางวัลรายเดือนได้เมื่อผู้เล่นใหม่ที่เชิญมีการเติมเงินผ่านช่องทางที่ 3",
    "ruleText6" : "6.รางวัลรายเดือนจะอัปเดตทุกวันที่ 1 ของเดือน",
    "ruleText7" : "7.สามารถรับคูปองได้ในหน้าชำระเงินของฝ่ายที่ 3 หากหมดอายุ จะไม่สามารถรับย้อนหลัง",
    "ruleText8" : "8.สกุลเงินของคูปองยึดสกุลเงินของการเติมเงินครั้งสุดท้ายเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อฝ่ายบริการลูกค้า",
    "ruleText9" : "9.ทั้งสองฝ่ายไม่สามารถผูกมัดโค้ดเชิญของฝ่ายตรงข้าม",
    "ruleTableTitle1" : "กติกาของรางวัลแชร์มีดังนี้：",
    "ruleTableTitle2" : "ระดับ VIP และกติกาการแจกคูปองมีดังนี้ :",
    "ruleTableHead1" : "มาตรฐานเติมเงิน",
    "ruleTableHead2" : "มาตรฐานรางวัล",
    "ruleTableHead3" : "รางวัล",
    "ruleTableContent1" : "เชิญผู้เล่นใหม่ 5 คน",
    "ruleTableContent2" : "ผู้เล่นที่ผูกมัดเติมเงินถึง 1000USD",
    "errorTip" : "ทำรายการไม่สำเร็จ",
    "eventShareText1" : "Puzzles & Survival : โปรโมชั่นลดจัดเต็มคาราเบล เริ่มแล้ววันนี้",
    "eventShareText2" : "โบนัสสุดคุ้มมากมายรอคุณอยู่",
    "cartDoubleTip" : "ไม่สามารถใช้คูปองดับเบิ้ลกับรถเข็น",
    "codeTip3" : "ยังไม่ได้ล็อกอิน",
    "codeTip4" : "ขาดพารามิเตอร์",
    "codeTip5" : "ไม่สามารถผูกมัดรหัสเชิญของตนเอง",
    "codeTip6" : "สร้างโค้ดเชิญแล้ว",
    "payWelfare" : "โบนัสเติมเงิน",
    "wallet" : "วอลเล็ท",
    "myDiscount" : "คูปองของฉัน",
    "knowMore" : "ดูเพิ่มเติม",
    "backPay" : "กลับ",
    "curBalance" : "ยอดขณะนี้",
    "pay" : "เติมเงิน",
    "changeCoin" : "เปลี่ยนสกุลเงิน",
    "watchDesc" : "ดูรายละเอียด",
    "getMore" : "รับเพิ่มเติม",
    "getDiscount" : "เก็บคูปอง",
    "notOpenDiscountQuan" : "ขณะนี้ยังไม่มีกิจกรรม โปรดติดตาม",
    "abountZbit" : "เกี่ยวกับ \${Z-BIT}",
    "remain" : "คงเหลือ :",
    "payRemain" : "หลังชำระเงิน คาดว่าจะคงเหลือ",
    "payRemainExpiry" : "ยอดคงเหลือโดยประมาณ ${money} (หมดอายุ 1 ม.ค. 26, โปรดรีบใช้)",
    "balanceNotEnoughExpiry" : "ยอดเงินไม่เพียงพอ (หมดอายุ 1 ม.ค. 2026, ไม่รองรับการเติมเงิน)",
    "balanceNotEnoggh" : "ยอดเงินไม่เพียงพอ โปรดเติมเงินก่อน",
    "goToPay" : "ไปเติมเงิน",
    "chooseOtherPay" : "โปรดเลือกช่องทางชำระเงินอื่น",
    "payIntro" : "การเติมเงิน",
    "logRole" : "เลือกตัวละคร",
    "chooseProduct" : "เลือกไอเทม",
    "meAgree" : "ฉันได้อ่านและยินยอม",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "ก่อนใช้ \${Z-BIT} ต้องยืนยันผ่านรหัส OTP ก่อน",
    "dl3dvnVipRule1" : "1.เกมที่ร่วมกิจกรรม :  \${gameName}",
    "dl3dvnVipRule2" : "กิจกรรมแต่ละประเภท สามารถรับรางวัลได้เพียง 1 ครั้ง",
    "dl3dvnVipRule3" : "2. กิจกรรม \"ล็อกอินแจกคูปอง\" : เปิดหน้าเติมเงินครั้งแรก รับคูปองลด 15%",
    "dl3dvnVipRule4" : "3.กิจกรรม \"พอยท์ VIP\" : เมื่อพอยท์จากการซื้อสินค้าในหน้าชำระเงินทางการถึงเลเวลที่กำหนด จะสามารถรับคูปองและคูปองพิเศษประจำสัปดาห์ของเลเวลที่ถึงได้",
    "dl3dvnVipRule5" : "4.อัตราพอยท์ของแต่ละสกุลเงินสามารถดูได้ในตาราง 1 หากถึงไม่ถึง 1 พอยท์ จะไม่นับ",
    "dl3dvnVipRule6" : "5.หากการสั่งซื้อใช้คูปอง พอยท์จะถูกคำนวณตามยอดการชำระแท้จริง",
    "dl3dvnVipRule7" : "6.พอยท์มีอายุ 365 วัน และเลเวล VIP จะเปลี่ยนแปลงตามพอยท์ปัจจุบันที่เป็นผล",
    "dl3dvnVipRule8" : "7.เมื่อถึง VIP ที่กำหนด ก็สามารถรับคูปองที่ถึงในครั้งแรก และคูปองประจำสัปดาห์ของเลเวลใหม่ จากนั้น จะแจกคูปองประจำสัปดาห์ทุกสัปดาห์ ในเวลาเที่ยงคืนของทุกวันเสาร์ (UTC+0)",
    "dl3dvnVipRule9" : "8.ในการรับคูปองประจำสัปดาห์ จะต้องล็อกอิน หากไม่มารับ จะไม่ชดเชยให้ และคูปองจะอัปเดตในเวลาที่กำหนด",
    "dl3dvnVipRule10" : "9.สกุลเงินของคูปองจะยึดสกุลเงินของออร์เดอร์เติมเงินสุดท้ายของคุณเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อเรา",
    "dl3dvnVipRule11" : "10.ระดับ VIP และคูปองที่แจก มีดังนี้ :",
    "dl3dvnVipRule12" : "11.กิจกรรมนี้ได้รับการสนับสนุนจากการชำระเงินของไทยและสามารถเล่นได้สำหรับผู้เล่นเขตไทยเท่านั้น",
    "dl3dvnVipRule13" : "12.ทีมงาน  \${gameName}  ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกา เงื่อนไข รวมถึงข้อกำหนดในกิจรรมนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "codeTip7" : "ผู้เล่นนี้ผูกมัดโค้ดเชิญของคุณแล้วๆ จึงไม่สามารถใช้โค้ดเชิญของเขาผูกมัดอีก",
    "ruleText10" : "10.Puzzles & Survival ขอสงวนสิทธิ์ในการเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "payCoins" : "เติมเงิน รับพอยท์ VIP",
    "shareGift" : "แชร์ทันที มีรางวัล",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "เนื่องจากพื้นที่ที่ผู้เล่นเลือกในฝ่ายที่สาม อาจไม่มีช่องทางชำระเงินที่ใช้ได้ ต้องแจ้งให้ผู้เล่นเปลี่ยนพิ้นที่ก่อน แล้วลองชำระเงินด้วยช่องทางอื่น",
    "dl3dtwVipRule1" : "1.เกมที่ร่วมกิจกรรม :  \${gameName}",
    "dl3dtwVipRule2" : "กิจกรรมแต่ละประเภท สามารถรับรางวัลได้เพียง 1 ครั้ง",
    "dl3dtwVipRule3" : "2.กิจกรรม \"พอยท์ VIP\" : เมื่อพอยท์จากการซื้อสินค้าในหน้าชำระเงินทางการถึงเลเวลที่กำหนด จะสามารถรับคูปองและคูปองพิเศษประจำสัปดาห์ของเลเวลที่ถึงได้",
    "dl3dtwVipRule4" : "3.อัตราพอยท์ของแต่ละสกุลเงินสามารถดูได้ในตาราง 1 หากถึงไม่ถึง 1 พอยท์ จะไม่นับ",
    "dl3dtwVipRule5" : "4.หากการสั่งซื้อใช้คูปอง พอยท์จะถูกคำนวณตามยอดการชำระแท้จริง",
    "dl3dtwVipRule6" : "5.พอยท์มีอายุ 365 วัน และเลเวล VIP จะเปลี่ยนแปลงตามพอยท์ปัจจุบันที่เป็นผล",
    "dl3dtwVipRule7" : "6.เมื่อถึง VIP ที่กำหนด ก็สามารถรับคูปองที่ถึงในครั้งแรก และคูปองประจำสัปดาห์ของเลเวลใหม่ จากนั้น จะแจกคูปองประจำสัปดาห์ทุกสัปดาห์ ในเวลาเที่ยงคืนของทุกวันเสาร์ (UTC+0)",
    "dl3dtwVipRule8" : "7.ในการรับคูปองประจำสัปดาห์ จะต้องล็อกอิน หากไม่มารับ จะไม่ชดเชยให้ และคูปองจะอัปเดตในเวลาที่กำหนด",
    "dl3dtwVipRule9" : "8.สกุลเงินของคูปองจะยึดสกุลเงินของออร์เดอร์เติมเงินสุดท้ายของคุณเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อเรา",
    "dl3dtwVipRule10" : "9.ระดับ VIP และคูปองที่แจก มีดังนี้ :",
    "dl3dtwVipRule11" : "10.ทีมงาน  \${gameName}  ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกา เงื่อนไข รวมถึงข้อกำหนดในกิจรรมนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "eventInviteSucc" : "เชิญสำเร็จ",
    "eventGainCondition" : "เงื่อนไขรับ",
    "eventSuccInvite" : "เชิญเพื่อนสำเร็จ",
    "eventInviteGainOne" : "ผุ้ถูกเชิญเติมเงินครบ\n49.99USD",
    "eventInviteGainTwo" : "ผุ้ถูกเชิญเติมเงินครบ\n99.99USD",
    "eventFriendCode" : "โค้ดเชิญเพื่อนที่คุณมีคือ :",
    "eventCheckBind" : "ยืนยันผูกมัดไหม?",
    "eventConfirm" : "ยืนยัน",
    "eventCancel" : "ยกเลิก",
    "eventBindSucc" : "ผูกมัดสำเร็จ!",
    "eventGainCoupon" : "ยินดีด้วย คุณได้รับคูปอง 1 ใบ!",
    "eventLookCoupon" : "ไปดูคูปอง",
    "eventSuccBind" : "ผูกมัดสำเร็จ",
    "recaptchaTip" : "โปรดทำการยืนยันก่อน",
    "completeRecaptcha" : "กรุณาทำการยืนยันตัวตนให้เสร็จสิ้น",
    "recaptchaExpired" : "การยืนยันหมดอายุแล้ว กรุณาลองอีกครั้ง",
    "inputAccountName" : "โปรดป้อนบัญชีที่ต้องการกู้คืน",
    "pwaPayTip" : "ชำระเงินได้เร็วกว่า ใช้ง่ายกว่า",
    "pwsInstall" : "เพิ่มสู่เดสก์ท็อป",
    "ztmslgType999" : "คูปอง",
    "coinUseTips" : "คูปองจะส่งให้ทางอีเมลภายในเกม สามารถนำไปซื้อสินค้าใดก็ได้ในคูปองมอลล์ของเกม และขณะใช้คูปอง จะได้รับรางวัลเติมเงินสะสม",
    "notice" : "ประกาศ",
    "popupConfirm" : "ยืนยัน",
    "hideWithinWeek" : "ใน 7 วันนี้ไม่แจ้งเตือนอีก",
    "ztmslgProductOffTips" : "ทีมงานได้รับข้อเสนอแนะเกี่ยวกับการอัปเดตเพจเติมเงินไม่น้อย ต้องขอขอบคุณทุกท่านที่ส่งฟีดแบ็กกันเข้ามา และเราก็ให้ความสำคัญกับฟีดแบ็กเหล่านี้มาก จึงต้องขอยกเลิกการอัปเดตที่เดิมแจ้งไว้ว่าจะออนไลน์ในวันที่ 13 มี.ค.นี้ ขณะเดียวกัน จะทำการปรับปรุงตามคำแนะนำของทุกท่าน ขอบคุณสำหรับการสนับสนุน และขออภัยในความไม่สะดวกมา ณ ที่นี้ด้วย\"",
    "couponTopLimit" : "อดโปรโมชั่นสูงสุดของสกุลเงินต่างๆ",
    "swsjpVipRule1" : "1. Event starts at 00:00 (UTC) 2023/03/24",
    "swsjpVipRule2" : "2.เกมที่ร่วมกิจกรรม : \${gameName}",
    "swsjpVipRule3" : "กิจกรรมแต่ละประเภท สามารถรับรางวัลได้เพียง 1 ครั้ง",
    "swsjpVipRule4" : "3. กิจกรรม \"ล็อกอินแจกคูปอง\" : เปิดหน้าเติมเงินครั้งแรก รับคูปองลด 15%",
    "swsjpVipRule5" : "4.กิจกรรม \"พอยท์ VIP\" : เมื่อพอยท์จากการซื้อสินค้าในหน้าชำระเงินทางการถึงเลเวลที่กำหนด จะสามารถรับคูปองและคูปองพิเศษประจำสัปดาห์ของเลเวลที่ถึงได้",
    "swsjpVipRule6" : "5.อัตราพอยท์ของแต่ละสกุลเงินสามารถดูได้ในตาราง 1 หากถึงไม่ถึง 1 พอยท์ จะไม่นับ",
    "swsjpVipRule7" : "6.หากการสั่งซื้อใช้คูปอง พอยท์จะถูกคำนวณตามยอดการชำระแท้จริง",
    "swsjpVipRule8" : "7.ประวัติการเติมเงินเก่าของผู้เล่นจะแปรเป็นพอยท์พื้นฐานตามอัตราที่กำหนด",
    "swsjpVipRule9" : "8.พอยท์มีอายุ 365 วัน และเลเวล VIP จะเปลี่ยนแปลงตามพอยท์ปัจจุบันที่เป็นผล",
    "swsjpVipRule10" : "9.เมื่อถึง VIP ที่กำหนด ก็สามารถรับคูปองที่ถึงในครั้งแรก และคูปองประจำสัปดาห์ของเลเวลใหม่ จากนั้น จะแจกคูปองประจำสัปดาห์ทุกสัปดาห์ ในเวลาเที่ยงคืนของทุกวันเสาร์ (UTC+0)",
    "swsjpVipRule11" : "10.ในการรับคูปองประจำสัปดาห์ จะต้องล็อกอิน หากไม่มารับ จะไม่ชดเชยให้ และคูปองจะอัปเดตในเวลาที่กำหนด",
    "swsjpVipRule12" : "11.สกุลเงินของคูปองจะยึดสกุลเงินของออร์เดอร์เติมเงินสุดท้ายของคุณเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อเรา",
    "swsjpVipRule13" : "12.ทีมงาน \${gameName} ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกา เงื่อนไข รวมถึงข้อกำหนดในกิจรรมนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "คูปอง",
    "passAskMods" : "สอบถาม mod",
    "passAskModsTip" : "สามารถสอบถามข้อสงสัยต่างๆ เกี่ยวกับเกมจาก mod ได้",
    "passService" : "สอบถามฝ่ายบริการลูกค้า",
    "passServiceTip" : "เกี่ยวกับบัญชี, ปัญหาการเติมเงิน ฯลฯ โปรดติดต่อฝ่ายบริการลูกค้า",
    "passIKonw" : "ทราบแล้ว",
    "passGoOn" : "สอบถามต่อ",
    "voucherTitle" : "ศูนย์เติมเงิน 37 Games",
    "voucherAddHome" : "เพิ่มสู่เดสก์ท็อป",
    "voucherAddHomeTipOne" : "ใช้ง่ายกว่า รวดเร็วกว่า",
    "voucherAddHomeTipTwo" : "แตะ [แชร์] ในแถบเครื่องมือ",
    "voucherAddHomeTipThree" : "และเลือก [เพิ่มสู่เดสก์ท็อป]",
    "voucherLoginLook" : "ล็อกอินเพื่อดูโปรโมชั่น",
    "voucherSwitchRole" : "เปลี่ยนตัวละคร",
    "voucherCoupon" : "บัตรส่วนลด",
    "voucherVip" : "แต้ม VIP",
    "voucherMoreCoupon" : "โปรโมชั่นอื่นๆ",
    "voucherAccountId" : "ID บัญชี",
    "voucherOtp" : "รหัส OTP",
    "voucherOtherWayPay" : "ชำระเงินด้วยช่องทางอื่น",
    "voucherOtherLoginWay" : "ล็อกอินด้วยช่องทางอื่น",
    "voucherCouponActivity" : "โปรโมชั่่น",
    "voucherActivityNotBegin" : "กิจกรรมยังไม่เริ่ม โปรดอดใจรอก่อน",
    "voucherGoCommunity" : "ไปดูโปรฯเติมเงินเพิ่มเติมที่โซเชียลของเรา",
    "voucherValidTime" : "ระยะเวลา",
    "voucherLimitRegion" : "ต้องใช้กับ \${currency} เท่านั้น",
    "voucherLiuyi" : "ไม่มีคูปแงที่ใช้ได้ โปรดติดตามกิจกรรมใหม่เร็วๆ นี้",
    "voucherPay" : "ซื้อคูปองเงินสด",
    "voucherAbout" : "เกี่ยวกับคูปองเงินสด",
    "voucherChooseWay" : "เลือกช่องทางชำระเงิน",
    "voucherMoreWay" : "ช่องทางชำระเงินอื่นๆ",
    "voucherChooseCoupon" : "เลือกคูปอง",
    "voucherHasChoose" : "เลือกแล้ว",
    "voucherMoneyInsufficient" : "ยอดเงินคงเหลือไม่เพียงพอ",
    "voucherContact" : "ยอดเงินคงเหลือไม่เพียงพอ โปรดติดต่อฝ่ายบริการลูกค้า",
    "voucherCouponTotal" : "ขณะนี้คงเหลือคูปอง :",
    "voucherCouponTipGuide" : "หลังเลือกช่องทางชำระเงิน สามารถเลือกใช้คูปองขณะสรุปยอดได้",
    "voucherPaytypeNotSupport" : "ช่องทางชำระเงินนี้ไม่สนับสนุนการใช้คูปอง",
    "voucherTipSideOne" : "คูปองสามารถใช้แลกแพ็กและบริการเสริมอื่นๆ ของเกมนี้ ยกเว้นคูปองได้",
    "voucherTipSideTwo" : "ลดสูงสุด 15%",
    "voucherYue" : "คงเหลือ",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "เซอร์ไวเวอร์ไกด์",
    "vipHeadText" : "ยินดีด้วย ท่านปลดล็อกกรอบโปรไฟล์พิเศษเฉพาะ VIP แล้ว",
    "vipHeadGetText" : "รับทันที",
    "vipHeadGotText" : "รับแล้ว",
    "vipHeadGetTitle" : "ยืนยันการรับ",
    "vipHeadGetTip" : "สามารถรับได้บัญชีละ 1 ครั้ง แน่ใจไหมว่าจะใช้ตัวละครนี้รับ?",
    "vipHeadAwardText" : "Best Commander (ถาวร)",
    "vipHeadGetErrTip1" : "รับล้มเหลว โปรดลองใหม่ภายหลังหรือติดต่อฝ่ายบริการลูกค้า",
    "cartGuideTipNew" : "เลือกซื้อไอเทมเพิ่ม รับส่วนลดคุ้มกว่า",
    "newVipTitle" : "ศูนย์เติมเงินสำหรับ VIP",
    "newVipLogin" : "ล็อกอิน",
    "newVipNowPoint" : "แต้มขณะนี้:",
    "newVipNextLevel" : "อัปเกรดเป็นเลเวลถัดไปในอีก \${point} แต้ม",
    "newVipUpgrade" : "อัปเกรด",
    "newVipLevel" : "โบนัส VIP",
    "newVipTip" : "รางวัลคูปองจะรีเซ็ตทุกวันเสาร์ เวลาเที่ยงคืน (UTC) ซึ่งจะแจกอัตโนมัติเมื่อล็อกอินหน้าเติมเงินทางการ",
    "newVipWeekly" : "แจกทุกสัปดาห์",
    "newVipReachPoint" : "เงื่อนไข:",
    "newVipRuleInfo" : "กติกา:",
    "pleaseLang" : "โปรดเลือกภาษา",
    "reference" : "เลขออเดอร์",
    "saveToNext" : "บันทึกเพื่อใช้ในการชำระครั้งถัดไป",
    "cardNum" : "เลขบัตร",
    "expireTime" : "หมดอายุ",
    "CVV" : "OTP",
    "pleaseCard" : "โปรดเลือกประเภทของบัตรเครดิต",
    "howToPay" : "ท่านต้องการชำระเงินด้วยวิธีใด?",
    "checkCard" : "โปรดตรวจสอบเลขบัตร",
    "checkExpiryDate" : "โปรดตรวจสอบวันหมดอายุ",
    "checkCVV" : "โปรดตรวจสอบ OTP",
    "addCard" : "เพิ่ม",
    "delete" : "ลบ",
    "deleteCardTips" : "ลบข้อมูลบัตรเครดิตที่บันทึกแล้ว",
    "confirmDelete" : "ใช่ ลบ",
    "cancelDelete" : "ยกเลิก",
    "checkAllCardMsg" : "สมัครสมาชิกล้มเหลว โปรดลองใหม่ภายหลังหรือติดต่อเรา",
    "leaveCreditPageTips" : "หากออกจากหน้านี้จะทำให้การชำระเงินล้มเหลว แน่ใจไหมว่าจะออก?",
    "sureToLeave" : "ออก",
    "continueToPay" : "ชำระเงินต่อ",
    "pushTest" : "ทดสอบการส่งข้อความพุช",
    "getNoticication" : "อุปกรณ์ไม่ได้รับข้อความพุชจากเกมใช่หรือไม่?",
    "waitCheckResult" : "โปรดอดใจรอสักครู่ นี่อาจเป็นเพราะตำแหน่งที่ตั้ง~",
    "hadAbnormal" : "ตรวจพบเหตุขัดข้องบางอย่างซึ่งอาจทำให้ไม่ได้รับข้อความพุช",
    "clickIntro" : "โปรดแตะเหตุขัดข้องเพื่อเช็ควิธีแก้ไข",
    "networkCheck" : "ตรวจสอบการเชื่อมต่อ",
    "noticeAuthorityCheck" : "ตรวจสอบสิทธิ์เข้าถึงการแจ้งเตือน",
    "noticeBtnCheck" : "ตรวจสอบการเปิด-ปิดแถบการแจ้งเตือน",
    "gmsCheck" : "ตรวจสอบบริการ GMS",
    "batteryCheck" : "ตรวจสอบรายการปรับปรุงแบตเตอรี่",
    "pushServiceCheck" : "ตรวจสอบบริการข้อความพุช",
    "reCheck" : "ตรวจสอบใหม่",
    "noNoticeAuthorityTip" : "อุปกรณ์ยังไม่ได้มอบสิทธิ์เข้าถึงข้อความพุชของเกม โปรดเลือกเกมและเปิดสิทธิ์เข้าถึงข้อความพุชของเกมในหน้าตั้งค่าระบบ-ข้อความพุช",
    "noNoticeBtnTip" : "ยังไม่ได้เปิดแถบการแจ้งเตือนของเกม โปรดเปิดแถบการแจ้งเตือนของเกมในหน้าตั้งค่า",
    "noBatteryTip" : "เกมอยู่ในรายการปรับปรุงแบตเตอรี่ของอุปกรณ์ จึงอาจไม่ได้รับข้อความพุช โปรดเพิ่มเกมเข้าไปในรายการที่อนุญาตในหน้าตั้งค่าระบบ-แบตเตอรี่-ปรับปรุงแบตเตอรี่",
    "noPushServiceTip" : "เชื่อมต่อบริการข้อความพุชล้มเหลว โปรดกดปุ่ม [เชื่อมต่อ] เพื่อเชื่อมต่อเซิร์ฟ",
    "noNetworkTip" : "ขณะนี้การเชื่อมต่อขัดข้อง โปรดลองใหม่หลังเชื่อมต่อกับการเชื่อมต่อที่เสถียร",
    "noGmsTip" : "อุปกรณ์นี้ไม่สนับสนุนบริการ Google Mobile (GMS) โปรดเปลี่ยนอุปกรณ์ล็อกอินที่สนับสนุนบริการ GMS เพื่อรับข้อความ",
    "pushConnectFail" : "เชื่อมต่อบริการส่งข้อความพุชล้มเหลว",
    "pushConnectSucc" : "เชื่อมต่อบริการส่งข้อความพุชสำเร็จ",
    "noGetPushTitle" : "หากยังคงไม่ได้รับข้อความพุช ท่านสามารถทำตามขั้นตอนดังนี้ได้ :",
    "noGetPushContOne" : "1. หลังออกจากเกมในอุปกรณ์เครื่องนี้ ให้ล็อกอินบัญชีเกมอีกครั้ง",
    "noGetPushContTwo" : "2. แตะ [ทดสอบการส่งข้อความพุช] ระบบจะทำการทดสอบอัตโนมัติ โปรดคอยสังเกตอุปกรณ์ปัจจุบันว่าได้รับข้อความหรือไม่",
    "noGetPushContThree" : "3. หากอุปกรณ์ได้รับข้อความพุช แต่ไม่ได้รับข้อความพุชของเกม โปรดตรวจสอบข้อความพุชที่เกี่ยวข้องในเกมที่ เกม-ตั้งค่า-ข้อความพุช ว่ามีการเปิดใช้หรือไม่",
    "noGetPushContFour" : "4. หากทำตามข้างต้นแล้วยังไม่ได้รับข้อความพุช โปรดติดต่อเรา",
    "getPushSucc" : "อุปกรณ์ได้รับข้อความพุชทดสอบข้อความที่แล้วสำเร็จ ฟังก์ชั่นข้อความพุชทำงานได้ตามปกติ!",
    "allCheckSucc" : "การทำงานทั้งหมดเป็นปกติ!",
    "pushCheck" : "ตรวจสอบการส่งข้อความพุช",
    "useDirectPay" : "ใช้ช่องทางชำระเงินเร่งด่วนสำเร็จ",
    "paypalFraudnetInfo" : "ข้อมูลการชำระเงินได้รับการคุ้มครองจากเอนจิ้นควบคุมความเสี่ยงของ Paypal",
    "goToSetting" : "ไปตั้งค่า",
    "retry" : "ลองใหม่",
    "connect" : "เชื่อมต่อ",
    "canRebind" : "หลังปลดการผูกมัด ท่านสามารถผูกมัดใหม่ได้",
    "agreePlatform" : "ฉันยินยอม\${service}และ\${privite}แล้ว",
    "sendGameNews" : "สมัครสมาชิก รับข่าวสารล่าสุด",
    "canNotBindEmail" : "หลังปลดการผูกมัด จะไม่สามารถใช้อีเมลนี้ล็อกอินได้",
    "canNotBindPhone" : "หลังปลดการผูกมัด จะไม่สามารถใช้เบอร์มือถือนี้ล็อกอินได้",
    "canChangeByEmail" : "สามารถเปลี่ยนการล็อกอินบนอุปกรณ์ต่างๆ ผ่านอีเมลได้",
    "canChangeByPhone" : "สามารถเปลี่ยนการล็อกอินบนอุปกรณ์ต่างๆ ผ่านเบอร์มือถือได้",
    "loginSucc" : "ล็อกอินสำเร็จ",
    "phoneHadBind" : "เบอร์มือถือนี้ใช้ผูกมัดแล้ว ต้องการล็อกอินเลยไหม?",
    "emailHadBind" : "อีเมลนี้ใช้ผูกมัดแล้ว ต้องการล็อกอินเลยไหม?",
    "phoneNotBind" : "เบอร์มือถือนี้้ยังไม่ได้ใช้ผูกมัด ต้องการสร้างบัญชีใหม่ไหม?",
    "emailNotBind" : "อีเมลนี้้ยังไม่ได้ใช้ผูกมัด ต้องการสร้างบัญชีใหม่ไหม?",
    "emailAccount" : "บัญชีอีเมล",
    "phoneAccount" : "บัญชีเบอร์มือถือ",
    "phoneInputError" : "เบอร์มือถือไม่ถูกต้อง",
    "registerNewAccount" : "สมัครบัญชีใหม่",
    "secureTip" : "เกี่ยวกับการเติมเงินผ่าน 3rd Party และความปลอดภัยของบัญชี",
    "toTop" : "ปักหมุด",
    "createNewWork" : "สร้างใบงานใหม่",
    "serviceEvaluate" : "ให้คะแนนฝ่ายบริการลูกค้า",
    "emailRemind" : "แจ้งทางอีเมล",
    "isAgreeService" : "โปรดให้คะแนนความพึงพอใจบริการของเรา",
    "thankEvaluateTop" : "ขอบคุณที่สละเวลาให้คะแนน!",
    "inputValidEmail" : "โปรดป้อนอีเมล",
    "replyWillRemind" : "หลังฝ่ายบริการลูกค้าตอบ ท่านจะได้รับการแจ้งเตือนทางอีเมล หากต้องการยกเลิกฟังก์ชั่นนี้ โปรดแตะฟังก์ชั่นแจ้งเตือนทางอีเมลอีกครั้ง",
    "isCancelEmailRemind" : "แน่ใจไหมว่าจะยกเลิกการแจ้งเตือนทางอีเมล? หลังยกเลิก ท่านจะไม่ได้รับการแจ้งเตือนทางอีเมล",
    "reconfirmEmail" : "โปรดตรวจสอบความถูกต้องของอีเมล",
    "confirmCanSubmit" : "หลังยืนยัน สามารถส่งใบงานได้",
    "serviceWillReply" : "หลังฝ่ายบริการลูกค้าตอบ จะแจ้งเตือนทางอีเมล",
    "cancelEmailRemind" : "แน่ใจไหมว่าจะยกเลิก [การแจ้งเตือนทางอีเมล]?",
    "yes" : "ใช่",
    "no" : "ไม่ใช่",
    "inputWorkSearch" : "โปรดป้อนคีย์เวิร์ดที่ต้องการค้นหา",
    "loading" : "กำลังดาวน์โหลด",
    "loadingError" : "ดาวน์โหลดล้มเหลว โปรดแตะเพื่อดาวน์โหลดใหม่...",
    "noMore" : "ไม่มีเนื้อหาแล้ว",
    "cancelToTop" : "ยกเลิกปักหมุด",
    "evaluateOne" : "ไม่พอใจมาก",
    "evaluateTwo" : "ไม่พอใจ",
    "evaluateThree" : "เฉยๆ",
    "evaluateFour" : "พอใจ",
    "evaluateFive" : "พอใจมาก",
    "confirmDelWorkTop" : "แน่ใจไหมว่าจะลบใบงานนี้?",
    "reRemindEmail" : "ต้องการรับการแจ้งเตือนผ่านอีเมลอีกครั้งไหม? ท่านสามารถกด [แจ้งเตือนอีเมล] อีกครั้งได้",
    "confirmWillReply" : "หลังยืนยัน เมื่อฝ่ายบริการลูกค้าตอบ จะแจ้งเตือนทางอีเมล",
    "thankEvaluateBottom" : "เราจะนำไปพัฒนา และปรับปรุงการบริการให้ดียิ่งขึ้น!",
    "confirmDelWorkBottom" : "หลังลบ จะไม่ได้รับคำตอบนะ~",
    "morePurchaseWay" : "ช่องทางเติมเงินอื่นๆ",
    "purchaseNeed" : "ขณะซื้อ ต้องใช้ :",
    "videoUploadSucc" : "อัปโหลดคลิปสำเร็จ",
    "videoUploadFail" : "อัปโหลดคลิปล้มเหลว",
    "videoUploadLimit" : "อัปโหลดได้เฉพาะคลิป mp4 ต้องมีขนาดไม่เกิน 400Mb และต้องมีความยาวไม่เกิน 2 นาที",
    "imageUploadSucc" : "อัปโหลดรูปภาพสำเร็จ",
    "imageUploadFail" : "อัปโหลดรูปภาพล้มเหลว",
    "uploading" : "กำลังอัปโหลด",
    "smartOrderCreate" : "สร้างใบงานเร่งด่วน",
    "smartOrderSearch" : "ค้นหา",
    "smartOrderComing" : "เร็วๆ นี้",
    "smartOrderContactService" : "ติดต่อเรา",
    "smartOrderDetector" : "วินิจฉัยปัญหา",
    "smartOrderDetect" : "วินิจฉัย",
    "smartOrderDetecting" : "กำลังวินิจฉัย",
    "smartOrderDetectTip" : "ตรวจสอบพบปัญหาที่ท่านพบเจอระหว่างเล่นเกม โปรดแตะวินิจฉัย เพื่อให้เราช่วยหาตำแหน่งที่แน่นอนของปัญหาของท่าน",
    "smartOrderDetectTip2" : "พบตำแหน่งที่แน่นอนของปัญหาแล้ว หลังส่งใบงาน เราจะช่วยท่านแก้ไขโดยเร็วที่สุด!",
    "smartOrderSubmit" : "ส่ง",
    "smartOrderIKnow" : "ทราบแล้ว",
    "smartOrderConfirm" : "ยืนยัน",
    "smartOrderLook" : "เช็คดู",
    "smartOrderIsHelp" : "บทความนี้มีประโยชน์ต่อท่านหรือไม่?",
    "smartOrderInputQuestion" : "โปรดป้อนปัญหาของท่าน",
    "smartOrderPleaseInpt" : "โปรดป้อน",
    "smartOrderPleaseChoose" : "โปรดเลือก",
    "smartOrderStoreTime" : "เวลาที่เติมเงิน",
    "smartOrderInputOrder" : "โปรดป้อนรหัสออเดอร์",
    "smartOrderInputPrice" : "โปรดป้อนยอดเงินของออเดอร์",
    "smartOrderNeedHelp" : "สวัสดีค่ะ มีอะไรให้ช่วยไหมคะ?",
    "smartOrderLookHelpTip" : "ท่านสามารถเช็ควิธีแก้ไขของปัญหาที่พบบ่อยได้",
    "smartOrderNoResult" : "ไม่พบผลลัพธ์ที่ต้องการค้นหา โปรดลองค้นหาเนื้อหาอื่น",
    "smartOrderUpdateTime" : "เวลาแก้ไขล่าสุด",
    "smartOrderSelectStoreTime" : "โปรดเลือกเวลาเติมเงิน",
    "smartOrderAtlestChoose" : "โปรดป้อนอย่างต่ำ 1 ข้อ",
    "workHomeTitle": "ศูนย์บริการลูกค้า",
    "workHomeCurServer": "เซิร์ฟเวอร์ปัจจุบัน",
    "workHomeSearchPlaceholder": "ป้อนคำสำคัญเพื่อค้นหาคำตอบอย่างรวดเร็ว",
    "workHomeSelfService": "บริการด้วยตนเอง",
    "workHomeAiService": "บริการลูกค้าอัจฉริยะ",
    "workHomeArtificialService": "เจ้าหน้าที่บริการ",
    "workHomeServiceEntrance": "เราพร้อมให้บริการคุณด้วยความเต็มใจ",
    "pwaInstallAward" : "เพิ่มลงในเดสก์ท็อป",
    "getMasonry" : "รับรางวัลเพชร",
    "addToDrawerVisit" : "เพิ่มไปยังเดสก์ท็อปเพื่อความสะดวกในการเข้าครั้งต่อไป",
    "immeAddToGet" : "เพิ่มแล้ววจะได้รับรางวัลจำกัดเวลาได้ทันที",
    "add" : "เพิ่ม",
    "talkNextTime" : "ค่อยว่ากันใหม่",
    "chooseRoleGetGift" : "เลือกตัวละครเพื่อรับรางวัล",
    "getGiftSuccess" : "รับสำเร็จ โปรดตรวจสอบรางวัลในเกม",
    "dmaTitle" : "โฆษณาที่ปรับตามความสนใจ",
    "dmaTitleSub" : "(ไม่บังคับ)",
    "newAdd" : "เพิ่ม",
    "smartDelete" : "ลบ",
    "wordLengthTip" : "(0-600 ตัวอักษร)",
    "areaLimitSwitchRegion" : "เปลี่ยนพื้นที่",
    "areaLimitCurrentRegionCurrency" : "พื้นที่และสกุลเงินในปัจจุบัน",
    "areaLimitRegion" : "พื้นที่:",
    "areaLimitCurrency" : "สกุลเงิน:",
    "areaLimitNote" : "ข้อสังเกต:",
    "areaLimitSwitchLimitation" : "ทุกบัญชีสามารถเปลี่ยนพื้นที่ได้เพียงครั้งเดียวเท่านั้นในตลอดปี",
    "areaLimitPostSwitchCoupon" : "หลังจากเปลี่ยนสำเร็จ คูปองส่วนลดที่ได้รับใหม่จะมอบให้ตามสกุลเงินที่สอดคล้องกับพื้นที่ใหม่",
    "areaLimitRemainingSwitches" : "ครั้งที่เหลือในปัจจุบัน: \${times}",
    "areaLimitNoRemainingSwitches" : "ไม่มีครั้งที่เหลือแล้ว",
    "areaLimitUnableToSwitchThisYear" : "ไม่สามารถแก้ไขได้อีกภายในปีนี้",
    "areaLimitCannotSwitch" : "ไม่สามารถแก้ไขได้",
    "areaLimitNavigateToSwitch" : "ไปแก้ไข",
    "areaLimitConfirmSwitch" : "ยืนยันแก้ไข",
    "areaLimitPreSwitchRegionCurrency" : "พื้นที่และสกุลเงินก่อนเปลี่ยน",
    "areaLimitPostSwitchRegionCurrency" : "พื้นที่และสกุลเงินหลังเปลี่ยน",
    "areaLimitPostSwitchRestriction" : "หลังจากเปลี่ยนสำเร็จ จะไม่สามารถเปลี่ยนพื้นที่ในการชำระเงินได้อีกภายในปีนี้",
    "areaLimitUnusedZBitWarning" : "คุณยังมี Z-Bits ที่ยังไม่ได้ใช้ หลังจากเปลี่ยนพื้นที่แล้วจะไม่สามารถใช้ Z-Bits ได้ ยืนยันจะดำเนินการต่อหรือไม่?",
    "areaLimitConfirm" : "ยืนยัน",
    "areaLimitCancel" : "ยกเลิก",
    "areaLimitInconsistencyWarning" : "พื้นที่ที่คุณเยี่ยมเยือนไม่สอดคล้องกับพื้นที่ชำระเงินของคุณ",
    "areaLimitPromptToSwitch" : "ต้องการเปลี่ยนพื้นที่หรือไม่?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "รับรางวัล",
    "selectProductTitle" : "เลือกสินค้า",
    "hotSuggest" : "ฮิตนิยม",
    "inputKeywordSearch" : "กรอกคีย์เวิร์ดเพื่อค้นหา",
    "lookProductContent" : "รายละเอียด",
    "popupClose" : "ปิด",
    "productSwitch" : "เปลี่ยน",
    "confirmBuy" : "ซื้อ",
    "thinkLater" : "คิดดูก่อน",
    "areaLimitConfirmRegion" : "ยืนยันพื้นที่",
    "areaLimitContinuePay" : "ดำเนินการชำระเงินต่อ",
    "areaLimitSwitchLimitationTwice" : "ทุกบัญชีสามารถเปลี่ยนพื้นที่ได้ปีละสองครั้ง",
    "dtmslgVipRule1" : "1.เกมที่ร่วมกิจกรรม :  \${gameName}",
    "dtmslgVipRule2" : "กิจกรรมแต่ละประเภท สามารถรับรางวัลได้เพียง 1 ครั้ง",
    "dtmslgVipRule3" : "2.กิจกรรม \"พอยท์ VIP\" : เมื่อพอยท์จากการซื้อสินค้าในหน้าชำระเงินทางการถึงเลเวลที่กำหนด จะสามารถรับคูปองและคูปองพิเศษประจำสัปดาห์ของเลเวลที่ถึงได้",
    "dtmslgVipRule4" : "3.อัตราพอยท์ของแต่ละสกุลเงินสามารถดูได้ในตาราง 1 หากถึงไม่ถึง 1 พอยท์ จะไม่นับ",
    "dtmslgVipRule5" : "4.หากการสั่งซื้อใช้คูปอง พอยท์จะถูกคำนวณตามยอดการชำระแท้จริง",
    "dtmslgVipRule6" : "5.พอยท์มีอายุ 365 วัน และเลเวล VIP จะเปลี่ยนแปลงตามพอยท์ปัจจุบันที่เป็นผล",
    "dtmslgVipRule7" : "6.เมื่อถึง VIP ที่กำหนด ก็สามารถรับคูปองที่ถึงในครั้งแรก และคูปองประจำสัปดาห์ของเลเวลใหม่ จากนั้น จะแจกคูปองประจำสัปดาห์ทุกสัปดาห์ ในเวลาเที่ยงคืนของทุกวันเสาร์ (UTC+0)",
    "dtmslgVipRule8" : "7.ในการรับคูปองประจำสัปดาห์ จะต้องล็อกอิน หากไม่มารับ จะไม่ชดเชยให้ และคูปองจะอัปเดตในเวลาที่กำหนด",
    "dtmslgVipRule9" : "8.สกุลเงินของคูปองจะยึดสกุลเงินของออร์เดอร์เติมเงินสุดท้ายของคุณเป็นหลัก หากต้องการเปลี่ยนสกุลเงิน โปรดติดต่อเรา",
    "dtmslgVipRule10" : "9.ระดับ VIP และคูปองที่แจก มีดังนี้ :",
    "dtmslgVipRule11" : "10.ทีมงาน  \${gameName}  ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกา เงื่อนไข รวมถึงข้อกำหนดในกิจรรมนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
    "dtmslgType10010" : "โปรฯรายวัน",
    "dtmslgType10020" : "จำนวนจำกัด",
    "dtmslgType10030" : "ฮีโร่",
    "dtmslgType10040" : "อุปกรณ์ต่อสู้",
    "dtmslgType10050" : "รูน",
    "dtmslgType10060" : "โทเทม",
    "dtmslgType10070" : "หินศักดิ์สิทธิ์",
    "dtmslgType10080" : "มังกร",
    "dtmslgType10090" : "ทรัพยากร",
    "dtmslgType10100" : "วิจัยการก่อสร้าง",
    "dtmslgType10110" : "แรร์ไอเทม",
    "dtmslgType10120" : "อาวุธแห่งโชคชะตา",
    "dtmslgType10130" : "เพชร",
    "dtmslgType10140" : "คูปองเงินสด",
    "dtmslgType2" : "แพ็กกิจกรรม",
    "dtmslgType3" : "ศูนย์โบนัส",
    "dtmslgType4" : "แพ็กกระตุ้น",
    "dtmslgType5" : "แพ็กหน้าหลัก",
    "dtmslgType20010" : "แพ็กแบล็คฟรายเดย์",
    "dtmslgType20021" : "แพ็กห้าวัน",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "เนื่องจากเปลี่ยนฟังก์ชั่นใหม่ กิจกรรม “แต้ม VIP” เดิมจะสิ้นสุดลง\n" +
        "ขอให้คุณใช้ตั๋วโปรที่ได้รับจากกิจกรรม “แต้ม VIP” เดิมภายในเวลา เพื่อหลีกเลี่ยงตั๋วโปรหมดอายุ\n" +
        "เวลาสิ้นสุด:2024-08-19 เวลา 08:00:00 น.(utc)\n" +
        "หลังสิ้นสุดกิจกรรม คุณสามารถไปศูนย์สมาชิกเพื่อรับสิทธิประโยชน์มากมาย:\n" +
        "เคลียร์เควสรับแต้ม ใช้แต้ม จะสามารถแลกตั๋วโปร ไอเทมเกมและรางวัลอื่นๆ! ยังมีสิทธิประโยชน์สมาชิกพิเศษ จับรางวัลแต้มและกิจกรรมโบนัสอื่นๆ\n" +
        "โปรดอดใจรอก่อน",
    "263RightsIntro": "เนื่องจากเปลี่ยนฟังก์ชั่นใหม่ กิจกรรม “แต้ม VIP” เดิมจะสิ้นสุดลง\n" +
        "ขอให้คุณใช้ตั๋วโปรที่ได้รับจากกิจกรรม “แต้ม VIP” เดิมภายในเวลา เพื่อหลีกเลี่ยงตั๋วโปรหมดอายุ\n" +
        "เวลาสิ้นสุด:2024-09-28 เวลา 00:00:00 น.(utc)\n" +
        "หลังสิ้นสุดกิจกรรม คุณสามารถไปศูนย์สมาชิกเพื่อรับสิทธิประโยชน์มากมาย:\n" +
        "เคลียร์เควสรับแต้ม ใช้แต้ม จะสามารถแลกตั๋วโปร ไอเทมเกมและรางวัลอื่นๆ! ยังมีสิทธิประโยชน์สมาชิกพิเศษ จับรางวัลแต้มและกิจกรรมโบนัสอื่นๆ\n" +
        "โปรดอดใจรอก่อน",
    "goToRights" : "ไปศูนย์สมาชิก VIP",
    "oldVipIntro" : "ขอให้คุณใช้ตั๋วโปรที่ได้รับจากกิจกรรม “แต้ม VIP” เดิมภายในเวลา เพื่อหลีกเลี่ยงตั๋วโปรหมดอายุ",
    "pwa-20001" : "โปรดล็อกอินก่อน",
    "pwa-20002" : "พารามิเตอร์ไม่ถูกต้อง",
    "pwa-20003" : "ยังไม่ได้ผูกมัดตัวละคร",
    "pwa-20004" : "แจกรางวัลไม่สำเร็จ โปรดลองใหม่หรือติดต่อฝ่ายบริการลูกค้า",
    "pwa-20005" : "คุณเคยรับแพ็กนี้แล้ว",
    "pwa-20100" : "กิจกรรมยังไม่เริ่ม",
    "pwa-20101" : "กิจกรรมสิ้นสุดแล้ว",
    "pwa-20102" : "ยังไม่ถึงเวลารับรางวัล",
    "pwa-20103" : "หมดเวลารับรางวัลลแ้ว",
    "pwa-1001" : "ทำรายการบ่อยเกินไป",
    "pwaCommon" : "โปรดลองใหม่ภายหลลัง",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "ศูนย์เติมเงินทางการ",
    "headerSafeTip": "ปลอดภัยไร้ความเสี่ยง รวดเร็วทันใจ",
    "safeChecking": "…กำลังตรวจสอบสภาพแวดล้อมการชำระขณะนี้",
    "safeChecked": "ปลอดภัย ใช้อย่างวางใจ",
    "riskChecked": "มีความเสี่ยง โปรดดำเนินการอย่างรอบคอบ",
    "footerSafeTitle1": "ปลอดภัย",
    "footerSafeTitle2": "สะดวก",
    "footerSafeTitle3": "คุ้มค่า",
    "footerSafeTitle4": "ประสิทธิภาพสูง",
    "footerSafeContent1": "ศูนย์เติมเงินทางการ",
    "footerSafeContent2": "รองรับวิธีชำระหลายแบบ",
    "footerSafeContent3": "โปรโมชั่นลดราคา โบนัสจำกัดเวลามากมาย",
    "footerSafeContent4": "รวดเร็วทันใจ ไม่ต้องรอ",
    "limitedTimeActivityTitle" : "โบนัสจำกัดเวลา",
    "limitedTimeActivityTime" : "เวลากิจกรรรม:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(ขณะนี้ \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(อัตราแลกเปลี่ยนมีการเปลี่ยนแปลง ยึดจากหน้านี้เป็นหลัก)",
    "limitedTimeActivityNotAchieve" : "ไม่สำเร็จ",
    "limitedTimeActivityClaim" : "รับ",
    "limitedTimeActivityClaimed" : "รับแล้ว",
    "limitedTimeActivityTimeLeft" : "จำกัดเวลา: \${days}d \${hours}:\${minutes}:\${seconds}",
    "limitedTimeActivityRecord" : "บันทึกการรับ",
    "limitedTimeActivityAward" : "รางวัล",
    "limitedTimeActivityGotTime" : "เวลาการรับ",
    "limitedTimeActivityGotRole" : "รับตัวละคร",
    "limitedTimeActivityRule" : "กติกากิจกรรม",
    "limitedTimeActivity285Rule1" : "1.เวลากิจกรรม :  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2.ภายในเวลากิจกรรม เคลียร์เควสจำกัดเวลา จะสามารถรับรางวัล เควสแบ่งเป็นเควสรายสัปดาห์และเควสรายเดือน :",
    "limitedTimeActivity285Rule3" : "(1) เควสรายสัปดาห์ : แต่ละบัญชีจำกัดการเคลียร์ 1 ครั้ง จะรีเซ็ตทุกเที่ยงคืนของวันจันทร์",
    "limitedTimeActivity285Rule4" : "เควสล็อกอินรายสัปดาห์ : ภายในเวลาที่จำกัด เติมเงินหน้าเว็บล็อกอินสำเร็จ 1 ครั้ง ;",
    "limitedTimeActivity285Rule5" : "เติมเงินสำเร็จ 1 ครั้ง : ภายในเวลาที่จำกัด เติมเงินสำเร็จ 1 ครั้งในหน้าเติมเงินเว็บทางการ เติมยอดใดๆล้วนสามารถเคลียร์ภารกิจ",
    "limitedTimeActivity285Rule6" : "(2) เควสรายเดือน : แต่ละบัญชีจำกัดการเคลียร์ 1 ครั้ง จะรีเซ็ตทุกวันที่ 1 ของทุกเดือน",
    "limitedTimeActivity285Rule7" : "เควสล็อกอิน : ภายในเวลาที่จำกัด สำเร็จเติมเงินหน้าเว็บล็อกอิน 1 ครั้ง ;",
    "limitedTimeActivity285Rule8" : "เควสเติมเงินสะสม : ภายในเวลาที่จำกัด เติมเงินสะสมในหน้าเติมเงินเว็บทางการจนถึงระดับเควส จะสามารถรับรางวัล 1 ครั้ง",
    "limitedTimeActivity285Rule9" : "หมายเหตุ : เนื่องจากเวลากิจกรรมค่อนข้างนาน อัตราแลกเปลี่ยนอาจเกิดการเปลี่ยนแปลง ยอดเติมเงินจะยึดจากหน้านี้เป็นหลัก",
    "limitedTimeActivity285Rule10" : "3.ก่อนรับรางวัล โปรดเลือก 1 ตัวละครเพื่อรับ หลังรับ โปรดดูรางวัลในเกม",
    "limitedTimeActivityClaimAward" : "รับรางวัล",
    "limitedTimeActivityConfirmGot" : "ยืนยันรับ",
    "limitedTimeActivityGetSucc" : "รับสำเร็จ",
    "limitedTimeActivityGetFail" : "รับล้มเหลว โปรดลองใหม่ภายหลังหรือติดต่อฝ่ายบริการลูกค้า",
    "limitedTimeActivityFrequent" : "โปรดอย่าทำถี่",
    "limitedTimeActivityLoginFirst" : "โปรดล็อกอินก่อน",
    "limitedTimeActivityWrongParam" : "ข้อมูลผิดพลาด",
    "limitedTimeActivityOverTips" : "กิจกรรมหมดอายุ โปรดรีเฟรชหน้า",
    "preRightsIntro" : "เนื่องจากเปลี่ยนฟังก์ชั่นใหม่ กิจกรรม “แต้ม VIP” เดิมจะสิ้นสุดลงnเวลาสิ้นสุด:\${offLineDate}nขอให้คุณใช้ตั๋วโปรที่ได้รับจากกิจกรรม “แต้ม VIP” เดิมภายในเวลา เพื่อหลีกเลี่ยงตั๋วโปรหมดอายุnหลังสิ้นสุดกิจกรรม คุณสามารถไปศูนย์สมาชิกเพื่อรับสิทธิประโยชน์มากมาย:nเคลียร์เควสรับแต้ม ใช้แต้ม จะสามารถแลกตั๋วโปร ไอเทมเกมและรางวัลอื่นๆ! ยังมีสิทธิประโยชน์สมาชิกพิเศษ จับรางวัลแต้มและกิจกรรมโบนัสอื่นๆnโปรดอดใจรอก่อน",
    "riskTipTitle" : "ระมัดระวังพฤติกรรมละเมิดกฎและความเสี่ยงจากการฉ้อโกง",
    "riskTipContent" : "เรียนผู้เล่นที่รัก\n\nขณะนี้พวกเราสังเกตพบพฤติกรรมละเมิดกฎที่ทำลายระเบียบและความเป็นธรรมภายในเกมจากผู้เล่นบางส่วน ที่พบบ่อยคือ :\n\n1. เผยแพร่โฆษณาละเมิดกฎ : เผยแพร่โฆษณาละเมิดกฎผ่านช่องทางแชทและอื่น ๆ เช่น การซื้อขายทรัพยากรผิดกฎ การเติมเงินแทน เป็นต้น;\n2. ใช้บอทหรือโปรแกรมช่วย : ใช้บอทหรือโปรแกรมช่วยเพื่อรับทรัพยากรจำนวนมากอย่างผิดกฎภายในเกม;\n3. การเชิญผิดกฎ : ส่งการเชิญผิดกฎที่ไม่เกี่ยวข้องกับเนื้อหาเกมในขณะแชท เพื่อล่อลวงให้ติดต่อผ่านช่องทางนอกเกม(เช่น Line, Discord);\n4. การเติมเงินแทนอันผิดกฎ : ใช้การเติมเงินในราคาถูกเป็นตัวล่อ เพื่อหลอกลวงให้ผู้เล่นเติมเงินผ่านช่องทางที่ไม่ใช่ของเกม;\n5. การฉ้อโกงรูปแบบอื่น เช่น อ้างตนเป็นพนักงานเกม เป็นต้น\n\nพวกเราหวังแจ้งเตือนผู้เล่นทุกท่าน ขอให้ทุกท่านเก็บรักษาทรัพย์สินและข้อมูลส่วนตัวให้ดี โปรดอย่าหลงเชื่อข้อมูลละเมิดกฎและฉ้อโกง เนื่องจากพฤติกรรมละเมิดกฎเหล่านี้มีความเสี่ยงมากมาย ไม่เพียงแต่อาจทำให้ท่านเสี่ยงต่อการถูกขโมยบัญชี และอาจเข้าข่ายพฤติกรรมฉ้อโกง สำหรับความสูญเสียที่เกิดจากพฤติกรรมละเมิดกฎ พวกเราจะไม่รองรับการชดเชยใด ๆ\n\nสำหรับบัญชีที่ละเมิดกฎ พวกเราจะดำเนินบทลงโทษตามความรุนแรงและขอบเขตผลกระทบของการละเมิดกฎ ประกอบด้วย การตักเตือน การหักผลประโยชน์จากการละเมิดกฎ การแบนบัญชีเกมชั่วคราวหรือถาวร และบทลงโทษอื่น ๆ หากคุณพบพฤติกรรมน่าสงสัยใดก็ตามภายในเกม สามารถร้องเรียนกับเราผ่านฝ่ายบริการลูกค้า เราจะเร่งยืนยันพร้อมมอบบทลงโทษทันที ขอขอบคุณสำหรับความเข้าใจและการสนับสนุนของคุณ",
    "linkValid": "ลิงก์นี้หมดอายุแล้ว",
    "-" : "-",
    "accountLabel": "บัญชี",
    "passwordLabel": "รหัสผ่าน",
    "confirmPasswordLabel": "ยืนยันรหัสผ่าน",
    "confirmDeleteTitle" : "โปรดยืนยันว่าจะลบบัญชีเกมและตัวละครทั้งหมดภายในบัญชีหรือไม่",
    "confirmDeleteYes" : "ใช่ ฉันยืนยันที่จะลบบัญชีเกมและตัวละครทั้งหมดภายในบัญชี",
    "selectGame" : "โปรดเลือกเกม",
    "confirmDeleteNo" : "ไม่ ฉันแค่ต้องการลบตัวละครบางตัว โดยเก็บบัญชีเกมไว้",
    "delTermsTitle" : "โปรดอ่านเงื่อนไขและข้อควรทราบในการลบบัญชีโดยละเอียด",
    "delCondTitle" : "1.เงื่อนไขลบบัญชี",
    "delCond1" : "(1) บัญชีเกมนี้และตัวละครเกมภายในเป็นข้าพเจ้าที่สมัครและใช้งาน <span>โปรดยื่นขอใหม่หลังล็อกอินบัญชี</span> หากบัญชีไม่สามารถล็อกอิน โปรดดำเนินการ[กู้บัญชี]ก่อน",
    "delCond2" : "(2) บัญชีเกมนี้และตัวละครเกมภายใน<span>ไม่มีความเสี่ยงด้านความปลอดภัย</span> ประกอบด้วย : ไม่มีการร้องเรียน, ฟ้องร้อง, ตรวจสอบ, การตัดสินและอื่น ๆ รวมถึงการถูกร้องเรียน, ถูกฟ้องร้อง, ถูกตรวจสอบ, ถูกตัดสินและอื่น ๆ ที่ถูกดำเนินแต่ยังไม่เสร็จสิ้น",
    "delCond3" : "(3) บัญชีเกมนี้และตัวละครเกมภายใน<span>ไม่มียอดเงินที่ยังไม่ชำระและกำลังรอชำระ</span> ประกอบด้วย เงินคืนที่ยังไม่ชำระ การสมัครสมาชิกที่ยังไม่ยกเลิกและอื่น ๆ",
    "delNoticeTitle" : "2.ข้อควรทราบลบบัญชี",
    "delNotice1" : "(1) คุณยื่นขอลบบัญชีเกมนี้และตัวละครเกมภายใน หาก<span>ลบเสร็จสิ้น จะไม่สามารถล็อกอิน ไม่สามารถกู้คืน</span>",
    "delNotice2" : "(2) โปรด<span>ดำเนินการชำระทรัพย์สินเกมภายในบัญชีและตัวละครเกมของคุณก่อน</span> ประกอบด้วย ไอเทมเกม คูปองเกม การสมัครสมาชิกเกมและอื่น ๆ หากลบเสร็จสิ้น ทรัพย์สินภายในเกมจะถูกลบทั้งหมด หลังเกมปิดเซิร์ฟ จะไม่ดำเนินการคืนเงินสำหรับบัญชีและตัวละครที่ลบแล้ว",
    "delNotice3" : "(3) หากลบข้อมูลบัญชีเกมและตัวละครภายใน ข้อมูลที่เกี่ยวข้องกับบัญชีนี้จะถูกลบหรือปกปิดชื่อ แต่ข้อมูลล็อกอินผ่านสื่อโซเชียลบุคคลที่สาม(เช่น ล็อกอิน Facebook และอื่นๆ) ขอให้ผู้เล่นดำเนินการปลดพร้อมลบข้อมูลแพลตฟอร์มสอดคล้องด้วยตนเอง",
    "delNotice4" : "(4) เพื่อสิทธิประโยชน์ของคุณ เราจะมีช่วงรักษาให้คุณ 14 วัน(บางพื้นที่ถูกยกเว้นเนื่องจากกฎหมายท้องถิ่น) หรือช่วงคูลดาวน์ ภายในช่วงคูลดาวน์ คุณสามารถติดต่อฝ่ายบริการลูกค้าเพื่อยื่นขอยกเลิกการลบ",
    "delNotice5" : "(5) หากคุณส่งยื่นขอลบบัญชีสำเร็จ เราจะอายัดทันที แต่การลบข้อมูลต้องใช้เวลาดำเนินการประมาณ 1 สัปดาห์ ด้วยเหตุนี้ เราจะแจ้งเตือนให้คุณทราบทันทีหลังลบเสร็จสิ้นผ่านอีเมล",
    "delFormConfirm1" : "ฉันได้อ่านพร้อมรับทราบเงื่อนไขและผลกระทบจากการลบบัญชีแล้ว",
    "delFormConfirm2" : "บัญชีที่ฉันยื่นขอลบไม่มีการร้องเรียนและฟ้องร้องที่ยังไม่สิ้นสุด",
    "delForm" : "ฉันได้อ่านพร้อมตกลงกับ<a class=\"account-delete-link\" href=\"javascript:;\"><ข้อตกลงการยกเลิกบัญชี></a>",
    "cannotDeleteMsgTitle" : "ไม่สามารถลบบัญชี",
    "cannotDeleteMsg1" : "เนื่องจากบัญชีของคุณยังไม่บรรลุเงื่อนไขดังนี้ จึงไม่สามารถลบบัญชี:",
    "cannotDeleteMsg2" : "ระบบตรวจพบว่าคุณมีออเดอร์ที่ยังดำเนินการไม่สำเร็จ โปรดยื่นคำขอใหม่หลังดำเนินออเดอร์สำเร็จ",
    "cannotDeleteMsg3" : "ระบบตรวจพบว่าคุณมีเงินคืนที่ยังไม่ชำระชดเชย หลังชำระชดเชยเงินคืน จะสามารถยื่นคำขอลบบัญชี",
    "cannotDeleteMsg4" : "ระบบตรวจพบว่าคุณกำลังถูกผู้เล่นอื่นร้องเรียนหรือฟ้องร้อง โปรดยื่นคำขอใหม่หลังดำเนินออเดอร์สำเร็จ",
    "formCompleted" : "กรอกออเดอร์เสร็จสิ้น",
    "formCheckMsg1" : "ออเดอร์ของคุณกรอกเสร็จสิ้นแล้ว โปรดรอหลังพนักงานตรวจสอบค่อยกลับออเดอร์",
    "formCheckMsg2" : "คุณสามารถตรวจสอบความคืบหน้าการดำเนินออเดอร์ภายใน<span class=\"account-delete-link\">[ออเดอร์ของฉัน]</span>",
    "delEmailMsg1" : "คุณต้องการให้ส่งอีเมลแจ้งเตือนหลังลบสำเร็จหรือไม่?",
    "delEmailMsg2" : "เนื่องจากการลบบัญชีต้องจัดการกับข้อมูลจำนวนมาก ใช้เวลาในการลบประมาณ 1 สัปดาห์ ต้องการให้ส่งอีเมลแจ้งเตือนคุณไหม?",
    "delEmailMsg3" : "อีเมลที่คุณกรอกจะใช้สำหรับแจ้งเตือนเท่านั้น ไม่ใช่สำหรับกรณีอื่น",
    "delEmailConfirmYes" : "ใช่ โปรดแจ้งเตือนฉันทางอีเมล",
    "delEmailFill" : "โปรดกรอกอีเมลสำหรับแจ้งเตือน",
    "delEmailConfirmNo" : "ไม่ ไม่ต้องแจ้งเตือนทางอีเมล",
    "delCoolMsg1" : "จะเลือกใช้ช่วงคูลดาวน์ 14 วันหรือไม่?",
    "delCoolMsg2" : "ภายในช่วงคูลดาวน์ 14 วัน บัญชีของคุณจะถูกอายัด โดยคุณจะสามารถส่งยื่นยกเลิกการลบได้ตลอดเวลา หลัง 14 วัน หากคุณไม่ยกเลิก บัญชีจะถูกลบ และไม่สามารถกู้คืน",
    "delCoolMsg3" : "หากคุณเลือกไม่ต้องการช่วงคูลดาวน์ สามารถดำเนินการลบบัญชีหลังยื่นขอสำเร็จ และไม่สามารถกู้คืน",
    "delCoolConfirmYes" : "ใช่ ฉันหวังให้มีช่วงคูลดาวน์ 14 วัน",
    "delCoolConfirmNo" : "ไม่ ฉันหวังให้ลบทันที",
    "delSecondCheckMsg1" : "คุณยืนยันได้จัดการเนื้อหาทั้งหมดในบัญชีแล้ว พร้อมดำเนินการช่วงคูลดาวน์ของบัญชี? หลังดำเนินการ จะไม่สามารถล็อกอินบัญชีของคุณ",
    "delSecondCheckConfirmYes" : "ใช่ เริ่มทันที",
    "delResMsg1" : "ได้ส่งยื่นขอลบบัญชีของคุณแล้ว บัญชีดังนี้ถูกอายัดแล้ว ไม่สามารถล็อกอิน:",
    "gameName" : "ชื่อเกม :",
    "gameAccount" : "บัญชีเกม :",
    "delResMsg2" : "<span>โปรดแคปจอพร้อมคัดลอกข้อมูลบัญชีข้างต้น หากคุณต้องการกู้คืนบัญชีภายในช่วงคูลดาวน์ นี่จะเป็นเพียงหลักฐานเดียว</span>",
    "delResMsg3" : "ช่วงคูลดาวน์มี 14 วัน นับถอยหลัง :",
    "delResMsg4" : "หากคุณต้องการยกเลิกยื่นขอลบบัญชีภายในช่วงคูลดาวน์ โปรดแตะ[ติดต่อฝ่ายบริการลูกค้า]ด้านล่างภายในช่วงคูลดาวน์",
    "copyAccountInfo" : "คัดลอกข้อมูลบัญชี",
    "delResMsg5" : "คุณยื่นขอลบบัญชีสำเร็จแล้ว กำลังลบบัญชีปัจจุบัน ด้วยเหตุนี้ บัญชีของคุณจะไม่สามารถล็อกอินในขณะนี้",
    "delResMsg6" : "เนื่องจากการลบบัญชีต้องจัดการข้อมูลจำนวนมาก ต้องใช้เวลาจำกัด ด้วยเหตุนี้ ร่องรอยบัญชีจะไม่ถูกลบหมดในทันที เราต้องใช้เวลาประมาณ 1 สัปดาห์กว่าจะสำเร็จ",
    "delResMsg7" : "หากก่อนหน้านี้คุณได้กรอกอีเมลแจ้งเตือนไว้แล้ว เราจะส่งไปยังอีเมลที่คุณระบุไว้",
    "delResMsg8" : "หากต้องการล็อกอินเกมอีกครั้ง สามารถสมัครบัญชีใหม่เพื่อล็อกอิน",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "ช่องทางอื่น",
    "itemWrong" : "ข้อนี้กรอกผิดพลาด โปรดกรอกใหม่",
    "delRegisterTime" : "เวลาสมัคร",
    "delDevice" : "รุ่นประจำ",
    "delIp" : "IP ประจำ",
    "delHistoryPayChannel" : "ช่องทางการเติมเงินในอดีต",
    "delHistoryPayOrder" : "ประวัติหมายเลขสั่งซื้อการเติมเงิน",
    "delDeleteReason" : "สาเหตุที่ลบบัญชี",
    "delPrevStep" : "ขั้นที่แล้ว",
    "delNextStep" : "ขั้นถัดไป",
    "delSecondCheckMsg2" : "คุณยืนยันว่าได้จัดการเนื้อหาทั้งหมดภายในบัญชีแล้ว พร้อมดำเนินการลบบัญชีทันทีไหม? หลังดำเนินการ จะไม่สามารถล็อกอินบัญชีของคุณ",
    "pleaseFillIn" : "กรุณากรอกข้อมูลดังนี้",
    "switchNewVersion": "เปลี่ยนไปยังแพลตฟอร์ม",
    "switchNewVersionPlatform": "การชำระเงินเวอร์ชันใหม่",
    "updateVersionPopupContent": "เพื่อให้มั่นใจถึงประสิทธิภาพการเล่นเกมที่ราบรื่นและการสนับสนุนฟังก์ชันใหม่ในอนาคต เราขอแนะนำให้คุณอัปเกรดระบบอุปกรณ์เพื่อเพลิดเพลินกับประสบการณ์การทำงานที่เสถียรและการปรับปรุงความเข้ากันได้",
    selectTopupTips:"ผู้เล่น 90% เลือกศูนย์เติมเงินทางการ",
    chuzhi: "เติมเงิน",
    selectMethods: "วิธีการชำระเงิน",
    landscapeTip2: "กรุณาหมุนโทรศัพท์เป็นโหมดแนวตั้งเพื่อประสบการณ์ที่ดีขึ้น",
    v3LaunchFromDesktopAndRewardToMailbox: 'กรุณาเปิดจากเดสก์ท็อป\nเลือกตัวละครแล้วรางวัลจะถูกส่งไปยังกล่องจดหมาย',
    ckoNotAvailable: 'เกิดข้อผิดพลาดในบริการชำระเงิน โปรดลองอีกครั้งในภายหลัง',
    ckoSubmitFail: 'การชำระเงินล้มเหลว โปรดตรวจสอบข้อมูลหรือใช้บัตรอื่น หากมีการหักเงินแล้ว เงินจะถูกคืนไปยังช่องทางที่ใช้ชำระเงินเดิม',
    gotoFinish: 'ต้องทำ',
    inAppPurchase: 'การซื้อภายในแอป',
}